export type Language = 'en' | 'ar';

export type Translations = {
  greetingMorning: string;
  greetingAfternoon: string;
  greetingEvening: string;
  todaysFocus: string;
  todaysFocusHeader: string;
  todaysFocusEmpty: string;
  todaysFocusAddButton: string;
  todaysFocusStartButton: string;
  todaysFocusStartSession: string;
  dayStreak: string;
  streakDays: string;
  streakTooltip: string;
  levelPrefix: string;
  levelTooltip: string;
  addTask: string;
  student: string;
  filterAllSubjects: string;
  filterAllPriorities: string;

  // Landing Page Refactor
  landingStickyScrollItem1Title: string;
  landingStickyScrollItem1Desc: string;
  landingStickyScrollBadgeOldWay: string;
  landingStickyScrollBadgeNoStructure: string;
  landingStickyScrollBadgeCramming: string;
  landingStickyScrollBadgeBurnout: string;
  landingStickyScrollItem2Title: string;
  landingStickyScrollItem2Desc: string;
  landingStickyScrollBadgeTriyoWay: string;
  landingStickyScrollBadgeAutoSchedule: string;
  landingStickyScrollBadgeGradePred: string;
  landingStickyScrollBadgeSmartBreaks: string;
  landingStickyScrollItem3Title: string;
  landingStickyScrollItem3Desc: string;
  landingStickyScrollBadgeSaved: string;
  landingStickyScrollBadgeEfficiency: string;

  landingStackCard1Title: string;
  landingStackCard1Desc: string;
  landingStackCard1List1: string;
  landingStackCard1List2: string;
  landingStackCard1List3: string;

  landingStackCard2Title: string;
  landingStackCard2Desc: string;
  landingStackCard2List1: string;
  landingStackCard2List2: string;
  landingStackCard2List3: string;

  landingStackCard3Title: string;
  landingStackCard3Desc: string;
  landingStackCard3Stat: string;

  landingSocialProofTitle: string;
  landingAITutorTitle: string;
  landingAITutorDesc: string;

  featureShowcasePlannerTitle: string;
  featureShowcasePlannerDesc: string;
  featureShowcaseGamificationTitle: string;
  featureShowcaseGamificationDesc: string;
  featureShowcaseGradesTitle: string;
  featureShowcaseGradesDesc: string;
  featureShowcaseGroupsTitle: string;
  featureShowcaseGroupsDesc: string;

  // Categories
  featureCatAcademics: string;
  featureCatGamification: string;
  featureCatSocial: string;

  // New Specific Features
  featureShowcaseAitutorTitle: string;
  featureShowcaseAitutorDesc: string;
  featureShowcaseKanbanTitle: string;
  featureShowcaseKanbanDesc: string;
  featureShowcasePetTitle: string;
  featureShowcasePetDesc: string;
  featureShowcaseTimerTitle: string;
  featureShowcaseTimerDesc: string;
  featureShowcaseLeaderboardTitle: string;
  featureShowcaseLeaderboardDesc: string;
  featureShowcaseWellnessTitle: string;
  featureShowcaseWellnessDesc: string;
  featureShowcaseAnalyticsTitle: string;
  featureShowcaseAnalyticsDesc: string;
  featureShowcaseStudyCompanionTitle: string;
  featureShowcaseStudyCompanionDesc: string;
  featureShowcaseFocusModeTitle: string;
  featureShowcaseFocusModeDesc: string;
  featureShowcaseGodRaysTitle: string;
  featureShowcaseGodRaysDesc: string;


  // Menu
  menuDashboard: string;
  menuStudyGroups: string;
  menuLeaderboards: string;
  menuAccountability: string;
  menuGrades: string;
  menuWeeklyPlan: string;
  menuDailyPlan: string; // New
  menuRewards: string;   // New
  menuAnalytics: string;
  menuSettings: string;
  logout: string;

  // Leaderboards
  leaderboardsSeasonLabel: string;
  leaderboardsHeroTitle: string;
  leaderboardsHeroSubtitle: string;
  leaderboardsHeroMyRank: string;
  leaderboardsGroupTitle: string;
  leaderboardsGroupSubtitle: string;
  leaderboardsLoading: string;
  leaderboardsJoinGroup: string;
  leaderboardsGroupDescriptionFallback: string;
  leaderboardsMembersBadge: string;
  leaderboardsTableRank: string;
  leaderboardsTableMember: string;
  leaderboardsTableXP: string;
  leaderboardsTableFocusMinutes: string;
  leaderboardsTableStreak: string;
  leaderboardsTableEmpty: string;
  leaderboardsGlobalTitle: string;
  leaderboardsGlobalSubtitle: string;
  leaderboardsGlobalEmpty: string;
  leaderboardsGlobalEntryMeta: string;
  leaderboardsMomentumTitle: string;
  leaderboardsMomentumTip1: string;
  leaderboardsMomentumTip2: string;
  leaderboardsMomentumTip3: string;
  leaderboardsSparkTitle: string;
  leaderboardsSparkSubtitle: string;
  leaderboardsLoadError: string;

  // Analytics
  analyticsTitle: string;
  analyticsBackToDashboard: string;
  analyticsRangeLabel: string;
  analyticsRange14: string;
  analyticsRange30: string;
  analyticsRefresh: string;
  analyticsFocusMinutesHeading: string;
  analyticsSubjectHeading: string;
  analyticsSubjectEmpty: string;
  analyticsTaskTableHeading: string;
  analyticsTaskLabel: string;
  analyticsSubjectLabel: string;
  analyticsMinutesLabel: string;
  analyticsNoSessions: string;
  analyticsLoading: string;
  analyticsLoadError: string;
  analyticsUnknownSubject: string;
  analyticsUnknownTask: string;
  analyticsMinutesSuffix: string;

  // Stats
  totalTasks: string;
  toDo: string;
  studying: string;
  done: string;

  // Kanban Columns
  toStudy: string;
  studyingNow: string;
  review: string;
  completed: string;
  kanbanClearAll: string;
  kanbanEmptyColumn: string;
  kanbanEmptyToStudy: string;
  kanbanEmptyStudying: string;
  kanbanEmptyReview: string;
  kanbanEmptyDone: string;

  // Dashboard social snapshot
  socialStudyGroupsTitle: string;
  socialStudyGroupsSubtitleDefault: string;
  socialStudyGroupsSubtitlePending: string;
  socialStudyGroupsButton: string;
  socialLeaderboardsTitle: string;
  dashboardWorkspace: string;
  socialLeaderboardsValueCTA: string;
  socialLeaderboardsSubtitleRanked: string;
  socialLeaderboardsSubtitleCTA: string;
  socialLeaderboardsButton: string;
  socialAccountabilityTitle: string;
  socialAccountabilitySubtitlePending: string;
  socialAccountabilitySubtitleDefault: string;
  socialAccountabilityButton: string;

  // Search & Filters
  searchPlaceholder: string;
  allSubjects: string;
  allPriorities: string;

  // Task Card
  priority: string;
  dueDate: string;
  delete: string;
  edit: string;
  save: string;
  cancel: string;
  startFocus: string;

  // New Task Modal
  createTask: string;
  editTask: string;
  taskTitle: string;
  taskTitlePlaceholder: string;
  description: string;
  descriptionPlaceholder: string;
  subject: string;
  dueDateTime: string;
  status: string;
  newStudyTask: string;
  whatToStudy: string;
  detailsNotes: string;
  checklist: string;
  addStep: string;
  resources: string;
  pasteURL: string;
  pinToBoard: string;
  ntmSubtitle: string;
  ntmCatTask: string;
  ntmCatExam: string;
  ntmCatProject: string;
  ntmCatOther: string;
  ntmTitleLabel: string;
  ntmErrTitleRequired: string;
  ntmErrTitleMax: string;
  ntmErrFutureTime: string;
  ntmEstTime: string;
  ntmDifficulty: string;
  ntmType: string;
  ntmTypeTagsPlaceholder: string;
  ntmRecurringLabel: string;
  ntmAISuggest: string;
  ntmAIEstimate: string;
  ntmThinking: string;
  ntmCancel: string;

  // ChatBot
  cbPersonaBuddy: string;
  cbPersonaProfessor: string;
  cbPersonaSocratic: string;
  cbPersonaELI5: string;
  cbQuickSummarize: string;
  cbQuickQuiz: string;
  cbQuickPlan: string;
  cbQuickExplain: string;
  cbSelectPersona: string;
  cbPoweredBy: string;
  cbContext: string;
  cbClear: string;
  cbUpload: string;
  cbPastePlaceholder: string;
  cbHello: string;
  cbIntroBuddy: string;
  cbIntroSocratic: string;
  cbImageAttached: string;
  cbAskPlaceholder: string;

  // Priority Levels
  high: string;
  medium: string;
  low: string;

  // Subjects
  math: string;
  cs: string;
  science: string;
  history: string;
  language: string;
  other: string;

  // Auth Page
  welcomeBack: string;
  loginSubtitle: string;
  signUp: string;
  signUpSubtitle: string;
  email: string;
  password: string;
  loginButton: string;
  signUpButton: string;
  switchToSignUp: string;
  switchToLogin: string;
  magicLinkSent: string;
  checkEmail: string;

  // Welcome Spotlight
  welcomeSpotlightTag: string;
  welcomeTitle: string;
  welcomeSubtitle: string;
  welcomeFeaturePlanLabel: string;
  welcomeFeaturePlanDetail: string;
  welcomeFeatureFocusLabel: string;
  welcomeFeatureFocusDetail: string;
  welcomeFeatureCommunityLabel: string;
  welcomeFeatureCommunityDetail: string;
  welcomeFeatureRewardsLabel: string;
  welcomeFeatureRewardsDetail: string;
  welcomeCTA: string;
  welcomeSkip: string;
  welcomeAnimationAlt: string;

  // Messages
  deleteConfirm: string;
  emptySlot: string;
  loadingDesk: string;

  // Focus Timer
  focusMode: string;
  focusTime: string;
  breakTime: string;
  work: string;
  break: string;
  minutes: string;
  start: string;
  pause: string;
  resume: string;
  finish: string;
  finishSession: string;
  finishAndComplete: string;
  closeFocusTimerAria: string;
  startTimerAria: string;
  pauseTimerAria: string;
  resetIntervalAria: string;
  logFocusButtonTitle: string;
  completeTaskButtonTitle: string;
  focusSessionHint: string;
  breakSuggestionMessage: string;
  breakSuggestionStart: string;
  breakSuggestionSkip: string;
  focusSummaryTitle: string;
  breakSummaryTitle: string;
  logFocusAria: string;
  completeTaskAria: string;
  switchToWorkAria: string;
  switchToBreakAria: string;

  // AI Planner
  dailyPlanTitle: string;
  dailyPlanButton: string;
  dailyPlanSubtitle: string;
  dailyPlanEmpty: string;
  dailyPlanLoading: string;
  dailyPlanError: string;
  dailyPlanReady: string;
  dailyPlanHabits: string;
  dailyPlanRisks: string;
  dailyPlanReflection: string;
  dailyPlanBlocks: string;
  dailyPlanLogin: string;
  dailyPlanNoTasks: string;

  // Rewards & Gamification
  rewardsTitle: string;
  rewardsRefreshHint: string;
  rewardsCurrentLevelLabel: string;
  rewardsTotalXpLabel: string;
  rewardsProgressSummary: string;
  rewardsLongestFocusLabel: string;
  rewardsLongestFocusHint: string;
  rewardsAchievementsHeading: string;
  rewardsLevelLabel: string;
  rewardsLoginRequired: string;
  rewardsLoadError: string;
  rewardsErrorGeneric: string;
  rewardsErrorMissingColumns: string;
  rewardsErrorSchema: string;
  rewardsAchievementFirstFocusTitle: string;
  rewardsAchievementFirstFocusDescription: string;
  rewardsAchievementStreak3Title: string;
  rewardsAchievementStreak3Description: string;
  rewardsAchievementStreak7Title: string;
  rewardsAchievementStreak7Description: string;
  rewardsAchievementHourTitle: string;
  rewardsAchievementHourDescription: string;
  rewardsAchievementDailyDoubleTitle: string;
  rewardsAchievementDailyDoubleDescription: string;
  rewardsAchievementLevel5Title: string;
  rewardsAchievementLevel5Description: string;
  rewardsAchievementLevelReachedTitle: string;
  rewardsAchievementLevelReachedDescription: string;
  xpLabelSingular: string;
  xpLabelPlural: string;
  daysLabel: string;
  rewardsToastTitle: string;
  rewardsToastLevelStreak: string;
  rewardsToastTotalXp: string;
  rewardsToastErrorTitle: string;

  // Daily Habit Loop
  dailyQuestsTitle: string;
  dailyQuestsSubtitle: string;
  dailyQuestRewardLabel: string;
  dailyQuestComplete: string;
  dailyQuestUndo: string;
  dailyQuestsLoading: string;
  dailyQuestsEmpty: string;
  dailyBoosterTitle: string;
  dailyBoosterLocked: string;
  dailyBoosterReady: string;
  dailyChestTitle: string;
  dailyChestLocked: string;
  dailyChestClaim: string;
  dailyChestClaimed: string;
  dailyChestReadyHint: string;
  dailyCheckInTitle: string;
  dailyCheckInPrompt: string;
  dailyCheckInMoodLabel: string;
  dailyCheckInGoalLabel: string;
  dailyCheckInMoodPlaceholder: string;
  dailyCheckInGoalPlaceholder: string;
  dailyCheckInButton: string;
  dailyCheckInGenerating: string;
  dailyCheckInThanks: string;

  // ChatBot
  chatBotTitle: string;
  chatBotSubtitle: string;
  chatBotUpload: string;
  chatBotInputPlaceholder: string;
  chatBotStop: string;
  chatBotClear: string;
  chatBotContext: string;
  chatBotReady: string;
  chatBotReadySubtitle: string;
  chatBotRateLimit: string;
  chatBotFileTooLarge: string;
  chatBotMaterialTruncated: string;
  chatBotImageSelected: string;
  chatBotPromptLimit: string;
  chatBotRequests: string;
  chatBotMaterial: string;
  chatBotPrompt: string;
  chatBotThinking: string;
  chatBotParsingPDF: string;
  chatBotFileReadError: string;
  chatBotInjectionWarning: string;
  chatBotWhatIsThis: string;
  chatBotError: string;
  chatBotAborted: string;
  chatBotBadge: string;
  chatBotToggleMaterials: string;
  chatBotUploadImage: string;
  chatBotCancelResponse: string;

  // Grades Page
  gradesTitle: string;
  addCourse: string;
  noCourses: string;
  noCoursesSubtitle: string;
  target: string;
  totalWeight: string;
  currentGrade: string;
  assignmentName: string;
  weight: string;
  score: string;
  addItem: string;
  recoveryPlan: string;
  aiStudyAdvisor: string;
  editCourse: string;
  newCourse: string;
  courseName: string;
  targetGrade: string;
  deleteCourseConfirm: string;
  courseNamePlaceholder: string;
  gradesLoading: string;
  gradesLoadError: string;

  // Weekly Plan Page
  weeklyPlannerTitle: string;
  weeklyPlannerSubtitle: string;
  weekStarting: string;
  dashboardButton: string;
  plannedThisWeek: string;
  ofOpenTasks: string;
  coverage: string;
  coverageMessageEmpty: string;
  coverageMessageGood: string;
  coverageMessageLow: string;
  backlog: string;
  backlogSubtitle: string;
  backlogEmpty: string;
  filterTasks: string;
  dueThisWeek: string;
  aiHighlights: string;
  aiHighlightsSubtitle: string;
  aiHighlightsEmpty: string;
  dragDropTipsTitle: string;
  dragDropTips: string;
  askAiDraft: string;
  goalsLabel: string;
  goalsPlaceholder: string;
  commitmentsLabel: string;
  commitmentsPlaceholder: string;
  risksLabel: string;
  risksPlaceholder: string;
  generatePlanButton: string;
  clearBoardButton: string;
  savePlanButton: string;
  statusGenerated: string;
  statusSaved: string;
  statusCleared: string;
  statusNothingToSave: string;
  errorGenerate: string;
  errorSave: string;
  aiGenerationError: string;
  loadingTasks: string;
  loadError: string;
  backToDashboard: string;
  dropTasksHere: string;
  dragTasksHere: string;
  hideList: string;
  showList: string;
  sendToDay: string;
  chooseDay: string;
  overview: string;
  metrics: string;
  focusMinutes: string;
  restBlocks: string;
  stretchGoals: string;
  untitledTask: string;
  signInToGenerate: string;
  signInToSave: string;
  weeklyPlanNote: string;
  weeklyPlanSlot: string;
  tasks: string;

  // Study Groups Page
  studyGroupsPhaseLabel: string;
  studyGroupsHeroTitle: string;
  studyGroupsHeroSubtitle: string;
  studyGroupsInviteCodeLabel: string;
  studyGroupsStatusCreated: string;
  studyGroupsStatusJoin: string;
  studyGroupsStatusLeft: string;
  studyGroupsStatusPrivacySaved: string;
  studyGroupsStatusChallengeCreated: string;
  studyGroupsErrorLoad: string;
  studyGroupsErrorCreate: string;
  studyGroupsErrorJoin: string;
  studyGroupsErrorLeave: string;
  studyGroupsErrorPrivacy: string;
  studyGroupsErrorChallenge: string;
  studyGroupsErrorDetails: string;
  studyGroupsRosterLoading: string;
  studyGroupsRosterEmpty: string;
  studyGroupsYourGroupsTitle: string;
  studyGroupsYourGroupsLoading: string;
  studyGroupsYourGroupsEmpty: string;
  studyGroupsLaunchTitle: string;
  studyGroupsNameLabel: string;
  studyGroupsNamePlaceholder: string;
  studyGroupsDescriptionLabel: string;
  studyGroupsDescriptionPlaceholder: string;
  studyGroupsPrivacyLabel: string;
  studyGroupsPrivacyPublicLabel: string;
  studyGroupsPrivacyPublicHint: string;
  studyGroupsPrivacyInviteLabel: string;
  studyGroupsPrivacyInviteHint: string;
  studyGroupsPrivacyPrivateLabel: string;
  studyGroupsPrivacyPrivateHint: string;
  studyGroupsAllowInvitesLabel: string;
  studyGroupsCreateButton: string;
  studyGroupsJoinTitle: string;
  studyGroupsJoinCodeLabel: string;
  studyGroupsJoinCodePlaceholder: string;
  studyGroupsJoinButton: string;
  studyGroupsActiveDescriptionFallback: string;
  studyGroupsRoleLabel: string;
  studyGroupsStatusLabel: string;
  studyGroupsPrivacyControlsTitle: string;
  studyGroupsPrivacyMembersHint: string;
  studyGroupsPrivacySaveButton: string;
  studyGroupsMembersTitle: string;
  studyGroupsMembersLeaveButton: string;
  studyGroupsMemberFocus: string;
  studyGroupsMemberXp: string;
  studyGroupsChallengesTitle: string;
  studyGroupsChallengesSubtitle: string;
  studyGroupsChallengesEmpty: string;
  studyGroupsChallengesCreateTitle: string;
  studyGroupsChallengeTitleLabel: string;
  studyGroupsChallengeXpLabel: string;
  studyGroupsChallengeStartLabel: string;
  studyGroupsChallengeEndLabel: string;
  studyGroupsChallengeDescriptionLabel: string;
  studyGroupsChallengeTargetLabel: string;
  studyGroupsChallengeButton: string;
  studyGroupsChallengeDefaultTitle: string;
  studyGroupsChallengeDefaultDescription: string;
  studyGroupsEmptyStateTitle: string;
  studyGroupsEmptyStateSubtitle: string;

  // Group Goals & Activity
  groupGoalsTitle: string;
  groupGoalsEmpty: string;
  groupGoalsCreate: string;
  groupGoalsProgress: string;
  groupGoalsContribute: string;
  groupGoalsContributed: string;
  groupGoalsTargetLabel: string;
  groupGoalsUnitTasks: string;
  groupGoalsUnitMinutes: string;
  groupGoalsUnitSessions: string;
  groupGoalsCompleted: string;
  groupGoalsTitleLabel: string;
  groupGoalsDescriptionLabel: string;
  groupGoalsTargetDateLabel: string;
  groupGoalsTargetValueLabel: string;
  groupGoalsUnitLabel: string;
  groupActivityTitle: string;
  groupActivityEmpty: string;
  groupActivityGoalCreated: string;
  groupActivityGoalProgress: string;
  groupActivityGoalCompleted: string;
  groupActivityMemberJoined: string;
  groupActivityFocusSession: string;
  groupActivityTaskCompleted: string;

  // Accountability Page
  accountabilityPhaseLabel: string;
  accountabilityHeroTitle: string;
  accountabilityHeroSubtitle: string;
  accountabilityShareCodeLabel: string;
  accountabilityShareCodeButton: string;
  accountabilityStatusInviteSent: string;
  accountabilityStatusCheckIn: string;
  accountabilityStatusCopied: string;
  accountabilityStatusAlreadyChecked: string;
  accountabilityErrorLoad: string;
  accountabilityErrorInvite: string;
  accountabilityErrorUpdate: string;
  accountabilityErrorCheckIn: string;
  accountabilityErrorClipboard: string;
  accountabilityInviteTitle: string;
  accountabilityInviteDescription: string;
  accountabilityPartnerIdLabel: string;
  accountabilityPartnerIdPlaceholder: string;
  accountabilitySendInviteButton: string;
  accountabilityHowItWorksTitle: string;
  accountabilityHowItWorksStep1: string;
  accountabilityHowItWorksStep2: string;
  accountabilityHowItWorksStep3: string;
  accountabilityPendingTitle: string;
  accountabilityPendingSubtitle: string;
  accountabilityPendingLoading: string;
  accountabilityPendingEmpty: string;
  accountabilityIncomingLabel: string;
  accountabilityIncomingHint: string;
  accountabilityDeclineButton: string;
  accountabilityAcceptButton: string;
  accountabilityWaitingLabel: string;
  accountabilityWaitingHint: string;
  accountabilityCancelButton: string;
  accountabilityActiveTitle: string;
  accountabilityActiveSubtitle: string;
  accountabilityActiveEmpty: string;
  accountabilityPartnerLabel: string;
  accountabilityLastCheckIn: string;
  accountabilityStreakBadge: string;
  accountabilityPrivacyLabel: string;
  accountabilityCheckInButton: string;
  accountabilityCheckInLocked: string;
  accountabilityCheckInLoading: string;
  accountabilityEndLinkButton: string;
  accountabilityTabMyBuddies: string;
  accountabilityTabAddBuddy: string;
  accountabilityTabPending: string;
  accountabilityWeekProgress: string;
  accountabilityEmptyTitle: string;
  accountabilityEmptySubtitle: string;

  // Settings Modal
  settingsTitle: string;
  settingsSubtitle: string;
  settingsLanguage: string;
  settingsStudyPreferences: string;
  settingsRetentionHours: string;
  settingsWorkInterval: string;
  settingsBreakInterval: string;
  settingsSaveButton: string;
  settingsSaved: string;
  profileSectionTitle: string;
  profileFullNameLabel: string;
  profilePersonaLabel: string;
  profileTimezoneLabel: string;
  profileBioLabel: string;
  profileSaveButton: string;
  profileSaved: string;
  profileMissingName: string;
  profileSetupTitle: string;
  profileSetupSubtitle: string;

  // Landing Page
  landingNavFeatures: string;
  landingNavHowItWorks: string;
  landingNavPricing: string;
  landingNavFAQ: string;
  landingNavRoadmap: string;
  landingNavGetStarted: string;

  landingHeroBadge: string;
  landingHeroTitle1: string;
  landingHeroTitle2: string;
  landingHeroSubtitle: string;
  landingHeroCTA: string;
  landingHeroSecondaryCTA: string;

  landingSocialPartner1: string;
  landingSocialPartner2: string;
  landingSocialPartner3: string;
  landingSocialPartner4: string;

  landingProblemTitle: string;
  landingProblemItem1: string;
  landingProblemItem2: string;
  landingProblemItem3: string;
  landingProblemItem4: string;

  landingSolutionTitle: string;
  landingSolutionItem1: string;
  landingSolutionItem2: string;
  landingSolutionItem3: string;
  landingSolutionItem4: string;

  landingAITitlePrefix: string;
  landingAITitleSuffix: string;
  landingAISubtitle: string;
  landingAIFeature1Title: string;
  landingAIFeature1Desc: string;
  landingAIFeature2Title: string;
  landingAIFeature2Desc: string;
  landingAIFeature3Title: string;
  landingAIFeature3Desc: string;
  landingAIFeature4Title: string;
  landingAIFeature4Desc: string;
  landingAIFeature5Title: string;
  landingAIFeature5Desc: string;

  landingFeaturesTitle: string;
  landingFeaturesSubtitle: string;
  landingFeaturesItem1Title: string;
  landingFeaturesItem1Desc: string;
  landingFeaturesItem2Title: string;
  landingFeaturesItem2Desc: string;
  landingFeaturesItem3Title: string;
  landingFeaturesItem3Desc: string;
  landingFeaturesItem4Title: string;
  landingFeaturesItem4Desc: string;
  landingFeaturesItem5Title: string;
  landingFeaturesItem5Desc: string;
  landingFeaturesItem6Title: string;
  landingFeaturesItem6Desc: string;

  landingHowItWorksTitle: string;
  landingHowItWorksStep1Title: string;
  landingHowItWorksStep1Desc: string;
  landingHowItWorksStep2Title: string;
  landingHowItWorksStep2Desc: string;
  landingHowItWorksStep3Title: string;
  landingHowItWorksStep3Desc: string;

  landingRoadmapTitle: string;
  landingRoadmapSubtitle: string;
  landingRoadmapQ1Title: string;
  landingRoadmapQ1Item1: string;
  landingRoadmapQ1Item2: string;
  landingRoadmapQ1Item3: string;
  landingRoadmapQ2Title: string;
  landingRoadmapQ2Item1: string;
  landingRoadmapQ2Item2: string;
  landingRoadmapQ2Item3: string;
  landingRoadmapQ3Title: string;
  landingRoadmapQ3Item1: string;
  landingRoadmapQ3Item2: string;
  landingRoadmapQ3Item3: string;

  landingPricingTitle: string;
  landingPricingFreeTitle: string;
  landingPricingFreePrice: string;
  landingPricingFreeItem1: string;
  landingPricingFreeItem2: string;
  landingPricingFreeItem3: string;
  landingPricingFreeCTA: string;
  landingPricingPlusTitle: string;
  landingPricingPlusPrice: string;
  landingPricingPlusItem1: string;
  landingPricingPlusItem2: string;
  landingPricingPlusItem3: string;
  landingPricingPlusItem4: string;
  landingPricingJoinWaitlist: string;
  landingPricingJoinSuccess: string;
  landingPricingComingSoon: string;
  landingPricingEmailPlaceholder: string;

  landingFAQTitle: string;
  landingFAQ1Q: string;
  landingFAQ1A: string;
  landingFAQ2Q: string;
  landingFAQ2A: string;
  landingFAQ3Q: string;
  landingFAQ3A: string;
  landingFAQ4Q: string;
  landingFAQ4A: string;

  landingFooterTagline: string;
  landingFooterProduct: string;
  landingFooterLegal: string;
  landingFooterPrivacy: string;
  landingFooterTerms: string;
  landingFooterContact: string;
  landingFooterRights: string;

  // Landing Page - New Features
  landingWeeklyTitle: string;
  landingWeeklyDesc: string;
  landingWeeklyFeature1: string;
  landingWeeklyFeature2: string;
  landingWeeklyFeature3: string;

  landingHeroBullet1: string;
  landingHeroBullet2: string;
  landingHeroBullet3: string;
  landingCTAStartFree: string;
  landingCTAWatchDemo: string;

  landingProofStudents: string;
  landingProofSummit: string;
  landingProofPrivacy: string;
  landingProofAI: string;
  landingProofSupabase: string;

  landingComparisonTitle: string;
  landingComparisonOldWay: string;
  landingComparisonNewWay: string;

  landingFinalCTATitle: string;
  landingFinalCTASubtitle: string;

  landingGamificationTitle: string;
  landingGamificationDesc: string;
  landingGamificationFeature1: string;
  landingGamificationFeature2: string;
  landingGamificationFeature3: string;

  landingGradesTitle: string;
  landingGradesDesc: string;
  landingGradesFeature1: string;
  landingGradesFeature2: string;
  landingGradesFeature3: string;

  landingGroupsTitle: string;
  landingGroupsDesc: string;
  landingGroupsFeature1: string;
  landingGroupsFeature2: string;
  landingGroupsFeature3: string;

  landingStudentsTitle: string;
  landingStudentsDesc: string;
  landingStudentsItem1: string;
  landingStudentsItem2: string;
  landingStudentsItem3: string;
  landingStudentsCTA: string;

  landingUniTitle: string;
  landingUniDesc: string;
  landingUniItem1: string;
  landingUniItem2: string;
  landingUniItem3: string;
  landingUniCTA: string;

  // Feature Reveal Section
  landingRevealSectionTitle: string;
  landingRevealSectionHighlight: string;
  landingRevealDailyTitle: string;
  landingRevealDailyDesc: string;
  landingRevealWeeklyTitle: string;
  landingRevealWeeklyDesc: string;
  landingRevealGradesTitle: string;
  landingRevealGradesDesc: string;
  landingRevealAITitle: string;
  landingRevealAIDesc: string;
  landingAIChatQuestion: string;
  landingAIChatAnswer: string;
  landingRevealPhysicsTitle: string;
  landingRevealPhysicsDesc: string;
  landingRevealConnectTitle: string;
  landingRevealConnectDesc: string;

  // Beta Banner
  betaBannerPrefix: string;
  betaBannerText: string;
  betaBannerFeedback: string;

  // Grade Tracking Section (Restored)
  landingGradeTrackBadge: string;
  landingGradeTrackTitle: string;
  landingGradeTrackSubtitle: string;
  landingGradeTrackFeature1: string;
  landingGradeTrackFeature2: string;
  landingGradeTrackCard1Class: string;
  landingGradeTrackCard1Meta: string;
  landingGradeTrackCard1Grade: string;
  landingGradeTrackCard2Class: string;
  landingGradeTrackCard2Meta: string;
  landingGradeTrackCard2Grade: string;
  landingGradeTrackCard2MetaRising: string;
  landingGradeTrackCard3Class: string;
  landingGradeTrackCard3Meta: string;
  landingGradeTrackCard3Grade: string;
  landingGradeProgress: string;
  landingGradeTrackFloatBadge: string;


  // Auth Page New
  authPageTitleSignUp: string;
  authPageTitleSignIn: string;
  authPageSubtitleSignUp: string;
  authPageSubtitleSignIn: string;
  authPageGoogleContinue: string;
  authPageOrEmail: string;
  authPageEmailLabel: string;
  authPagePasswordLabel: string;
  authPageForgotPassword: string;
  authPageButtonSignUp: string;
  authPageButtonSignIn: string;
  authPageButtonLoadingSignUp: string;
  authPageButtonLoadingSignIn: string;
  authPageSwitchAccountQuestionSignUp: string;
  authPageSwitchAccountQuestionSignIn: string;
  authPageSwitchActionSignUp: string;
  authPageSwitchActionSignIn: string;
  authPageTOSPrefix: string;
  authPageTOSLink: string;
  authPagePrivacyLink: string;
  authPageSideTitle1: string;
  authPageSideTitle2: string;
  authPageSideSubtitle: string;
  authPageSideFeature1: string;
  authPageSideFeature2: string;
  authPageSuccessSignUp: string;
  authPageSuccessSignUpConfirm: string;
  and: string;

  // Forgot Password Page
  forgotPassTitle: string;
  forgotPassSubtitle: string;
  forgotPassLabelEmail: string;
  forgotPassButtonSend: string;
  forgotPassButtonSending: string;
  forgotPassBackToLogin: string;
  forgotPassSideTitle1: string;
  forgotPassSideTitle2: string;
  forgotPassSuccess: string;
  forgotPassErrorRateLimit: string;
  forgotPassErrorGeneric: string;

  // Reset Password Page
  resetPassTitle: string;
  resetPassSubtitle: string;
  resetPassLabelPass: string;
  resetPassLabelConfirm: string;
  resetPassButtonUpdate: string;
  resetPassButtonUpdating: string;
  resetPassSuccess: string;
  resetPassErrorMismatch: string;
  resetPassErrorLength: string;
  resetPassErrorInvalidLink: string;
  resetPassErrorGeneric: string;
  resetPassRequestNewLink: string;

  // Legal Modal
  legalModalIUnderstand: string;
  legalModalPrint: string;
  legalModalLastUpdated: string;
  legalModalQuickNav: string;
  legalModalSections: string;
  legalModalPrivacyTitle: string;
  legalModalTermsTitle: string;

  // Quota Indicator
  quotaUnlimited: string;
  quotaRemaining: string;
  quotaAiTips: string;
  quotaSmartTasks: string;
  quotaUpgrade: string;
  quotaLimitReached: string;
  quotaTodayFree: string;

  // Calendar Export
  calendarExport: string;
  calendarExportTitle: string;
  calendarExportTasksCount: string;
  calendarDownloadICS: string;
  calendarICSHint: string;
  calendarAddGoogle: string;
  calendarAddOutlook: string;
  calendarOpenNew: string;
  calendarExportAll: string;
  calendarExportDownloaded: string;
  calendarExporting: string;
  calendarPopupNote: string;
  calendarExportAllHint: string;

  // Project Teams Page
  projectTeamsLabel: string;
  projectTeamsTitle: string;
  projectTeamsSubtitle: string;
  projectTeamsNewProject: string;
  projectTeamsJoin: string;
  projectTeamsMyProjects: string;
  projectTeamsNoProjects: string;
  projectTeamsSelectProject: string;
  projectTeamsSelectProjectHint: string;
  projectTeamsCreateTitle: string;
  projectTeamsProjectName: string;
  projectTeamsProjectNamePlaceholder: string;
  projectTeamsDescriptionOptional: string;
  projectTeamsDescriptionPlaceholder: string;
  projectTeamsCancel: string;
  projectTeamsCreateButton: string;
  projectTeamsJoinTitle: string;
  projectTeamsInviteCodeLabel: string;
  projectTeamsEnterCode: string;
  projectTeamsJoinButton: string;
  projectTeamsInviteMember: string;
  projectTeamsLeaveProject: string;
  projectTeamsNoDescription: string;
  projectTeamsInviteTitle: string;
  projectTeamsInviteSubtitle: string;
  projectTeamsInviteCode: string;
  projectTeamsShareableLink: string;
  projectTeamsCopyLink: string;
  projectTeamsNoInviteCode: string;
  projectTeamsInvitesDisabled: string;
  projectTeamsClose: string;
  projectTeamsProjectBoard: string;
  projectTeamsAddTask: string;
  projectTeamsToDo: string;
  projectTeamsInProgress: string;
  projectTeamsDone: string;
  projectTeamsNoTasks: string;
  projectTeamsTeamMembers: string;
  projectTeamsNoMembers: string;
  projectTeamsTasksDone: string;
  projectTeamsAssignTo: string;
  projectTeamsNoTeamMembers: string;
  projectTeamsAnyone: string;
  projectTeamsOwner: string;
  projectTeamsMember: string;

  // AI Task Prompt
  aiPromptPlaceholder: string;
  aiNoTasksFound: string;
  aiParseError: string;
  aiTasksAdded: string;
  aiFoundTask: string;
  aiFoundTasks: string;
  aiAddAll: string;
  tryAgain: string;
};


export const englishTranslations: Translations = {
  greetingMorning: 'Good morning',
  greetingAfternoon: 'Good afternoon',
  greetingEvening: 'Good evening',
  todaysFocus: "Let's make today productive!",
  todaysFocusHeader: "Today's Focus",
  todaysFocusEmpty: "No focus tasks due today. You're all clear!",
  todaysFocusAddButton: "Add a Task",
  todaysFocusStartButton: "Start Focus",
  todaysFocusStartSession: "Start focus session",
  dayStreak: 'Day Streak',
  streakDays: 'day',
  streakTooltip: 'Daily study streak',
  levelPrefix: 'Lv.',
  levelTooltip: 'Your current level',
  addTask: 'Add Task',
  student: 'Student',
  filterAllSubjects: 'All Subjects',
  filterAllPriorities: 'All Priorities',

  // Landing Page Refactor
  landingStickyScrollItem1Title: "Chaos & Overwhelm",
  landingStickyScrollItem1Desc: "Scattered notes, missed deadlines, and the constant anxiety of 'what should I study now?'",
  landingStickyScrollBadgeOldWay: "The Old Way",
  landingStickyScrollBadgeNoStructure: "No Structure",
  landingStickyScrollBadgeCramming: "Last Minute Cramming",
  landingStickyScrollBadgeBurnout: "Burnout",
  landingStickyScrollItem2Title: "Your AI Operating System",
  landingStickyScrollItem2Desc: "Intelligent scheduling that adapts to your energy. Turn tasks into clear, actionable steps.",
  landingStickyScrollBadgeTriyoWay: "The Triyo Way",
  landingStickyScrollBadgeAutoSchedule: "Auto-Scheduling",
  landingStickyScrollBadgeGradePred: "Grade Prediction",
  landingStickyScrollBadgeSmartBreaks: "Smart Breaks",
  landingStickyScrollItem3Title: "Reclaim Your Time",
  landingStickyScrollItem3Desc: "Save 10+ hours a week on planning and stressing. Focus on learning, not logistics.",
  landingStickyScrollBadgeSaved: "Saved / Week",
  landingStickyScrollBadgeEfficiency: "Focus Efficiency",

  landingStackCard1Title: "The Old Way",
  landingStackCard1Desc: "Scattered notes, missed deadlines, and last-minute cramming.",
  landingStackCard1List1: "Scattered notes",
  landingStackCard1List2: "Missed deadlines",
  landingStackCard1List3: "Cramming",

  landingStackCard2Title: "The Triyo OS",
  landingStackCard2Desc: "A complete operating system for your academic life.",
  landingStackCard2List1: "AI Auto-Schedule",
  landingStackCard2List2: "Quest System",
  landingStackCard2List3: "Grade Forecasting",

  landingStackCard3Title: "Academic Success",
  landingStackCard3Desc: "Measurable results in just one semester.",
  landingStackCard3Stat: "GPA +0.5 Increase",

  landingSocialProofTitle: "POWERED BY EXCELLENCE",
  featureShowcaseAitutorTitle: "AI Tutor",
  featureShowcaseAitutorDesc: "Stuck on a problem? Get instant Socratic guidance, not just answers.",
  featureShowcasePlannerTitle: "Smart Weekly Planner",
  featureShowcasePlannerDesc: "Auto-schedule tasks with AI logic. Drag, drop, and let the system optimize your week.",
  featureShowcaseGamificationTitle: "Gamified Learning",
  featureShowcaseGamificationDesc: "Earn XP for every study session. Level up, unlock rewards, and compete on leaderboards.",
  featureShowcaseGradesTitle: "Grade Savior",
  featureShowcaseGradesDesc: "Visualize your academic performance. Calculate 'what-if' scenarios to save your GPA.",
  featureShowcaseGroupsTitle: "Collaborative Groups",
  featureShowcaseGroupsDesc: "Don't study alone. Share resources, chat with peers, and conquer courses together.",

  // Categories
  featureCatAcademics: "Core Academics",
  featureCatGamification: "Gamification & Focus",
  featureCatSocial: "Social & Wellness",

  // New Specific Features
  // (Aitutor moved up)
  featureShowcaseKanbanTitle: "Task Management",
  featureShowcaseKanbanDesc: "Organize assignments with board views, subtasks, and priority tags.",
  featureShowcasePetTitle: "Study Companion",
  featureShowcasePetDesc: "Hatch your own AI pet that grows as you study. Keep it happy by maintaining streaks!",
  featureShowcaseTimerTitle: "Focus Timer",
  featureShowcaseTimerDesc: "Customizable Pomodoro timer with deep focus mode and ambient sounds.",
  featureShowcaseLeaderboardTitle: "Leaderboards",
  featureShowcaseLeaderboardDesc: "Compete with friends or go global. Earn badges and climb the ranks.",
  featureShowcaseWellnessTitle: "Wellness Check-ins",
  featureShowcaseWellnessDesc: "Track your mood and energy. We'll suggest breaks when you're burning out.",
  featureShowcaseAnalyticsTitle: "Detailed Analytics",
  featureShowcaseAnalyticsDesc: "Visual insights into your peak productivity hours and subject mastery.",
  featureShowcaseStudyCompanionTitle: "Study Companion",
  featureShowcaseStudyCompanionDesc: "Hatch your own AI pet that grows as you study.",
  featureShowcaseFocusModeTitle: "Focus Mode",
  featureShowcaseFocusModeDesc: "Deep focus sessions with ambient sounds and task locking.",
  featureShowcaseGodRaysTitle: "Ambient Atmosphere",
  featureShowcaseGodRaysDesc: "Immersive background glows that shift with your study mood.",

  landingAITutorTitle: "AI Tutor",
  landingAITutorDesc: "Instant answers, simplified explanations, and Socratic guidance.",



  // Menu
  menuDashboard: 'Dashboard',
  menuStudyGroups: 'Study Groups',
  menuLeaderboards: 'Leaderboards',
  menuAccountability: 'Study Buddies',
  menuGrades: 'Grades',
  menuWeeklyPlan: 'Weekly Plan',
  menuDailyPlan: 'Daily Plan',
  menuRewards: 'Rewards',
  menuAnalytics: 'Analytics',
  menuSettings: 'Settings',
  logout: 'Logout',

  // Leaderboards
  leaderboardsSeasonLabel: 'Current Week',
  leaderboardsHeroTitle: 'Weekly Leaderboard',
  leaderboardsHeroSubtitle: 'Track your weekly progress and compete with the community. Resets every Monday.',
  leaderboardsHeroMyRank: 'Your Weekly Rank',
  leaderboardsGroupTitle: 'Group Leaderboards',
  leaderboardsGroupSubtitle: 'Real-time XP standings for every group you belong to.',
  leaderboardsLoading: 'Syncing stats...',
  leaderboardsJoinGroup: 'Join a study group to unlock collaborative leaderboards.',
  leaderboardsGroupDescriptionFallback: 'Aim high, stay accountable.',
  leaderboardsMembersBadge: '{count} members',
  leaderboardsTableRank: 'Rank',
  leaderboardsTableMember: 'Member',
  leaderboardsTableXP: 'XP',
  leaderboardsTableFocusMinutes: 'Focus min',
  leaderboardsTableStreak: 'Streak',
  leaderboardsTableEmpty: 'No progress yet - kick off a focus sprint!',
  leaderboardsGlobalTitle: 'Weekly Top Learners',
  leaderboardsGlobalSubtitle: 'Top performers this week.',
  leaderboardsGlobalEmpty: 'No stats yet this week. Complete a quest to enter the board.',
  leaderboardsGlobalEntryMeta: '{focusMinutes} focus min | {streakDays}-day streak',
  leaderboardsMomentumTitle: 'Momentum Tips',
  leaderboardsMomentumTip1: 'Stack small daily wins - XP compounds faster than you think.',
  leaderboardsMomentumTip2: 'Use shared challenges to keep everyone in sync each week.',
  leaderboardsMomentumTip3: 'Celebrate streak milestones publicly to boost morale.',
  leaderboardsSparkTitle: 'Need more spark?',
  leaderboardsSparkSubtitle: 'Upcoming: season-based rewards that reset every month. Stay tuned!',
  leaderboardsLoadError: 'Unable to load leaderboards right now.',

  // Analytics
  analyticsTitle: 'Study Analytics',
  analyticsBackToDashboard: 'Back to dashboard',
  analyticsRangeLabel: 'Range',
  analyticsRange14: '14 days',
  analyticsRange30: '30 days',
  analyticsRefresh: 'Refresh data',
  analyticsFocusMinutesHeading: 'Focus minutes per day',
  analyticsSubjectHeading: 'Focus minutes by subject',
  analyticsSubjectEmpty: 'No focus sessions with linked subjects yet.',
  analyticsTaskTableHeading: 'Task focus summary',
  analyticsTaskLabel: 'Task',
  analyticsSubjectLabel: 'Subject',
  analyticsMinutesLabel: 'Minutes',
  analyticsNoSessions: 'No focus sessions yet. Start a focus timer to see analytics.',
  analyticsLoading: 'Loading analytics...',
  analyticsLoadError: 'Unable to load analytics right now. Please refresh.',
  analyticsUnknownSubject: 'Other / Unassigned',
  analyticsUnknownTask: 'Unnamed task',
  analyticsMinutesSuffix: '{value} minutes',

  // Stats
  totalTasks: 'Total Tasks',
  toDo: 'To Do',
  studying: 'Studying',
  done: 'Done',

  // Kanban Columns
  toStudy: 'To Study',
  studyingNow: 'Studying Now',
  review: 'Review',
  completed: 'Done',
  kanbanClearAll: 'Clear All',
  kanbanEmptyColumn: 'No tasks',
  kanbanEmptyToStudy: 'Add a task to get started! 📚',
  kanbanEmptyStudying: 'Drag a task here when studying 💪',
  kanbanEmptyReview: 'Tasks to review will appear here 🔍',
  kanbanEmptyDone: 'Complete tasks to celebrate here! 🎉',

  socialStudyGroupsTitle: 'Study Groups',
  socialStudyGroupsSubtitleDefault: 'Privacy controls ready to tweak',
  socialStudyGroupsSubtitlePending: '{count} waiting for approval',
  socialStudyGroupsButton: 'Manage groups',
  socialLeaderboardsTitle: 'Leaderboards',
  dashboardWorkspace: 'Your Workspace',
  socialLeaderboardsValueCTA: 'Get ranked',
  socialLeaderboardsSubtitleRanked: 'Current global placement',
  socialLeaderboardsSubtitleCTA: 'Finish quests to enter top 50',
  socialLeaderboardsButton: 'View leaderboards',
  socialAccountabilityTitle: 'Study Buddies',
  socialAccountabilitySubtitlePending: '{count} buddy requests',
  socialAccountabilitySubtitleDefault: 'No pending buddy invites',
  socialAccountabilityButton: 'View buddies',

  // Search & Filters
  searchPlaceholder: 'Search notes...',
  allSubjects: 'All Subjects',
  allPriorities: 'All Priorities',

  // Task Card
  priority: 'Priority',
  dueDate: 'Due',
  delete: 'Delete',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  startFocus: 'Start Focus',

  // New Task Modal
  createTask: 'Create New Task',
  editTask: 'Edit Task',
  taskTitle: 'Task Title',
  taskTitlePlaceholder: 'e.g., Study for Math exam',
  description: 'Description',
  descriptionPlaceholder: 'Add details about this task...',
  subject: 'Subject',
  dueDateTime: 'Due Date & Time',
  status: 'Status',
  newStudyTask: 'New Study Task',
  whatToStudy: 'What do you need to study?',
  detailsNotes: 'Details/Notes',
  checklist: 'Checklist',
  addStep: 'Add a step...',
  resources: 'Resources',
  pasteURL: 'Paste URL...',
  pinToBoard: 'Pin to Board',
  ntmSubtitle: 'Add a study item to your Triyo board',
  ntmCatTask: 'Task',
  ntmCatExam: 'Exam',
  ntmCatProject: 'Project',
  ntmCatOther: 'Other',
  ntmTitleLabel: 'Title',
  ntmErrTitleRequired: 'Title required',
  ntmErrTitleMax: 'Max {max} chars',
  ntmErrFutureTime: 'Choose a future time',
  ntmEstTime: 'Est. Time (min)',
  ntmDifficulty: 'Difficulty',
  ntmType: 'Type',
  ntmTypeTagsPlaceholder: 'Add custom tags (comma separated)',
  ntmRecurringLabel: 'Recurring Task',
  ntmAISuggest: 'AI Suggest',
  ntmAIEstimate: 'AI Estimate',
  ntmThinking: 'Thinking...',
  ntmCancel: 'Cancel',

  // ChatBot
  cbPersonaBuddy: 'Study Buddy',
  cbPersonaProfessor: 'Professor',
  cbPersonaSocratic: 'Socratic',
  cbPersonaELI5: 'ELI5',
  cbQuickSummarize: 'Summarize this',
  cbQuickQuiz: 'Quiz me',
  cbQuickPlan: 'Create a study plan',
  cbQuickExplain: 'Explain key concepts',
  cbSelectPersona: 'Select Persona',
  cbPoweredBy: 'Powered by AI',
  cbContext: 'Study Context',
  cbClear: 'Clear',
  cbUpload: 'Upload File',
  cbPastePlaceholder: 'Paste notes, essay drafts, or assignment details here...',
  cbHello: "Hello! I'm your {persona}",
  cbIntroBuddy: "I'm here to help you ace your studies! What are we working on?",
  cbIntroSocratic: "I'm here to guide you to the answers, not just give them.",
  cbImageAttached: 'Image attached',
  cbAskPlaceholder: 'Ask anything...',

  // Priority Levels
  high: 'High',
  medium: 'Medium',
  low: 'Low',

  // Subjects
  math: 'Math',
  cs: 'CS',
  science: 'Science',
  history: 'History',
  language: 'Language',
  other: 'Other',

  // Auth Page
  welcomeBack: 'Welcome Back',
  loginSubtitle: 'Log in to Triyo',
  signUp: 'Create Account',
  signUpSubtitle: 'Start organizing your studies',
  email: 'Email',
  password: 'Password',
  loginButton: 'Login',
  signUpButton: 'Sign Up',
  switchToSignUp: "Don't have an account? Sign up",
  switchToLogin: 'Already have an account? Login',
  magicLinkSent: 'Magic Link Sent!',
  checkEmail: 'Check your email for the login link',

  // Welcome Spotlight
  welcomeSpotlightTag: 'Your smart study hub',
  welcomeTitle: 'Welcome to Triyo',
  welcomeSubtitle: 'Plan smarter, focus deeper, and grow with a calm accountability community.',
  welcomeFeaturePlanLabel: 'Plan with clarity',
  welcomeFeaturePlanDetail: 'Turn tasks into a weekly study roadmap with AI nudges.',
  welcomeFeatureFocusLabel: 'Stay in deep focus',
  welcomeFeatureFocusDetail: 'Launch Pomodoro-style sessions and log real study minutes.',
  welcomeFeatureCommunityLabel: 'Learn together',
  welcomeFeatureCommunityDetail: 'Create study groups, challenges, and accountability pairs.',
  welcomeFeatureRewardsLabel: 'Level up habits',
  welcomeFeatureRewardsDetail: 'Earn XP, streak badges, and gentle reminders to stay consistent.',
  welcomeCTA: "Let's get studying",
  welcomeSkip: 'Maybe later',
  welcomeAnimationAlt: 'Sparkling icons showing planning, focus, and community',

  // Messages
  deleteConfirm: 'Are you sure you want to shred this task?',
  emptySlot: 'Empty Slot',
  loadingDesk: 'Loading your desk...',

  // Focus Timer
  focusMode: 'Focus Mode',
  focusTime: 'Focus Time',
  breakTime: 'Break Time',
  work: 'Work',
  break: 'Break',
  minutes: 'minutes',
  start: 'Start',
  pause: 'Pause',
  resume: 'Resume',
  finish: 'Finish',
  finishSession: 'Log Focus',
  finishAndComplete: 'Complete Task',
  closeFocusTimerAria: 'Close focus timer',
  startTimerAria: 'Start timer',
  pauseTimerAria: 'Pause timer',
  resetIntervalAria: 'Reset current interval',
  logFocusButtonTitle: 'Logs the focus time without marking the task finished',
  completeTaskButtonTitle: 'Marks the task as completed and logs focus time (if >= 1 min)',
  focusSessionHint: 'Focus time is recorded once you reach at least 1 minute. Use "Log Focus" to just save progress; "Complete Task" finishes it and updates your streak.',
  breakSuggestionMessage: 'Great focus block! Ready for a {minutes} minute break?',
  breakSuggestionStart: 'Start Break',
  breakSuggestionSkip: 'Skip',
  focusSummaryTitle: 'Total focused time this session',
  breakSummaryTitle: 'Total break time this session',
  logFocusAria: 'Log focus time',
  completeTaskAria: 'Complete task and log focus time',
  switchToWorkAria: 'Switch to work interval',
  switchToBreakAria: 'Switch to break interval',

  // AI Planner
  dailyPlanTitle: 'AI Daily Plan',
  dailyPlanButton: "Generate Today's Plan (AI)",
  dailyPlanSubtitle: 'Turn your tasks into a realistic schedule for today.',
  dailyPlanEmpty: 'No AI plan yet. Tap the button to map out your day.',
  dailyPlanLoading: 'Asking the AI to build your schedule...',
  dailyPlanError: 'We could not build your plan. Please try again in a moment.',
  dailyPlanReady: 'Your plan is ready for today.',
  dailyPlanHabits: 'Suggested habits',
  dailyPlanRisks: 'Heads-up risks',
  dailyPlanReflection: 'Reflection prompt',
  dailyPlanBlocks: 'Focus blocks',
  dailyPlanLogin: 'Sign in to generate an AI plan.',
  dailyPlanNoTasks: 'Add at least one open task to generate a plan.',

  // Rewards & Gamification
  rewardsTitle: 'Your study rewards',
  rewardsRefreshHint: 'Updated whenever a focus session finishes',
  rewardsCurrentLevelLabel: 'Current level',
  rewardsTotalXpLabel: 'Total XP',
  rewardsProgressSummary: '{current} / {span} XP this level Â· {next} XP to next level',
  rewardsLongestFocusLabel: 'Longest focus',
  rewardsLongestFocusHint: 'Aim for 60+ for bonus badges',
  rewardsAchievementsHeading: 'Achievements',
  rewardsLevelLabel: 'Level {level}',
  rewardsLoginRequired: 'Sign in to see your rewards progress.',
  rewardsLoadError: 'Unable to load rewards progress right now. Please refresh.',
  rewardsErrorGeneric: 'We saved your focus time, but rewards could not update. Try again later.',
  rewardsErrorMissingColumns: 'Rewards are paused because the study_stats table is missing the new xp_total/level columns. Run the latest Supabase SQL migration, then try again.',
  rewardsErrorSchema: 'Rewards could not refresh due to an outdated Supabase schema cache. Re-run the study_stats migration or refresh the table definition.',
  rewardsAchievementFirstFocusTitle: 'First Focus!',
  rewardsAchievementFirstFocusDescription: 'Log at least one minute of focused work.',
  rewardsAchievementStreak3Title: 'Weekend Warrior',
  rewardsAchievementStreak3Description: 'Maintain a 3-day streak.',
  rewardsAchievementStreak7Title: 'Consistency Champ',
  rewardsAchievementStreak7Description: 'Keep your streak for a full week.',
  rewardsAchievementHourTitle: 'Deep Work Hour',
  rewardsAchievementHourDescription: 'Stay in a single focus block for 60 minutes.',
  rewardsAchievementDailyDoubleTitle: 'Daily Double',
  rewardsAchievementDailyDoubleDescription: 'Accumulate 120 minutes of focus in one day.',
  rewardsAchievementLevel5Title: 'Level Five Live',
  rewardsAchievementLevel5Description: 'Reach level 5 for bragging rights.',
  rewardsAchievementLevelReachedTitle: 'Level {level} reached',
  rewardsAchievementLevelReachedDescription: 'Your dedication is paying offâ€”enjoy the level up bonuses!',
  xpLabelSingular: '1 XP',
  xpLabelPlural: '{count} XP',
  daysLabel: 'days',
  rewardsToastTitle: 'Focus rewards unlocked',
  rewardsToastLevelStreak: 'Level {level} Â· Streak {streak} {days}',
  rewardsToastTotalXp: 'Total XP: {total}',
  rewardsToastErrorTitle: 'Rewards not updated',

  // Daily Habit Loop
  dailyQuestsTitle: 'Daily Habit Loop',
  dailyQuestsSubtitle: 'Complete quests to charge up your streak booster.',
  dailyQuestRewardLabel: '+{value} XP',
  dailyQuestComplete: 'Mark done',
  dailyQuestUndo: 'Undo',
  dailyQuestsLoading: 'Summoning fresh quests...',
  dailyQuestsEmpty: 'No quests for today yet. Check back soon!',
  dailyBoosterTitle: 'Streak Booster',
  dailyBoosterLocked: 'Finish all quests to unlock extra rewards.',
  dailyBoosterReady: 'Booster unlocked! Claim your bonus.',
  dailyChestTitle: 'Daily Reward Chest',
  dailyChestLocked: 'Unlocks after booster.',
  dailyChestClaim: 'Claim rewards',
  dailyChestClaimed: 'Rewards claimed',
  dailyChestReadyHint: 'Bonus XP gift',
  dailyCheckInTitle: 'AI Daily Check-In',
  dailyCheckInPrompt: 'How are you feeling? What do you want to achieve today?',
  dailyCheckInMoodLabel: 'Your vibe',
  dailyCheckInGoalLabel: "Today's goal",
  dailyCheckInMoodPlaceholder: 'e.g. Motivated but a bit tired',
  dailyCheckInGoalPlaceholder: 'Finish history outline + 1 practice quiz',
  dailyCheckInButton: 'Get motivation',
  dailyCheckInGenerating: 'Crafting your pep talk...',
  dailyCheckInThanks: "You've got this!",

  // ChatBot
  chatBotTitle: 'Study Buddy',
  chatBotSubtitle: 'Powered by AI',
  chatBotUpload: 'Upload PDF/Txt',
  chatBotInputPlaceholder: 'Ask a question...',
  chatBotStop: 'Stop',
  chatBotClear: 'Clear',
  chatBotContext: 'Study Material / Context',
  chatBotReady: 'Ready to study!',
  chatBotReadySubtitle: 'Paste your notes in the top section, or just ask me anything.',
  chatBotRateLimit: 'Rate limit exceeded. Please wait a few seconds.',
  chatBotFileTooLarge: 'File too large',
  chatBotMaterialTruncated: 'Material truncated',
  chatBotImageSelected: 'Image selected',
  chatBotPromptLimit: 'Prompt limit reached',
  chatBotRequests: 'Requests',
  chatBotMaterial: 'Material',
  chatBotPrompt: 'Prompt',
  chatBotThinking: 'Thinking...',
  chatBotParsingPDF: 'Parsing PDF... please wait.',
  chatBotFileReadError: 'Failed to read file: {error}',
  chatBotInjectionWarning: 'Potential prompt injection detected. Adjusted response scope.',
  chatBotWhatIsThis: 'What is this?',
  chatBotError: 'Oops! I lost my train of thought. Please check your API key or internet connection.',
  chatBotAborted: 'Streaming aborted by user.',
  chatBotBadge: 'AI',
  chatBotToggleMaterials: 'Toggle Materials',
  chatBotUploadImage: 'Upload Image',
  chatBotCancelResponse: 'Cancel response',

  // Grades Page
  gradesTitle: 'Grade Calculator',
  addCourse: 'Add Course',
  noCourses: 'No courses yet',
  noCoursesSubtitle: 'Add a course to start tracking your grades.',
  target: 'Target',
  totalWeight: 'Total Weight',
  currentGrade: 'Current Grade',
  assignmentName: 'Assignment Name',
  weight: 'W',
  score: 'Score',
  addItem: 'Add Item',
  recoveryPlan: 'Recovery Plan',
  aiStudyAdvisor: 'AI Study Advisor',
  editCourse: 'Edit Course',
  newCourse: 'New Course',
  courseName: 'Course Name',
  courseNamePlaceholder: 'e.g. Calculus I',
  targetGrade: 'Target Grade (%)',
  deleteCourseConfirm: 'Are you sure you want to delete this course?',
  gradesLoading: 'Loading your desk...',
  gradesLoadError: 'Failed to load grades. Please try again.',

  // Weekly Plan Page
  weeklyPlannerTitle: 'Weekly Planner',
  weeklyPlannerSubtitle: 'Plan your week, organise tasks by day, and save the schedule to your study sessions.',
  weekStarting: 'Week starting',
  dashboardButton: 'Dashboard',
  plannedThisWeek: 'Planned this week',
  ofOpenTasks: 'of {total} open tasks',
  coverage: 'Coverage',
  coverageMessageEmpty: 'Add tasks to start planning.',
  coverageMessageGood: 'Momentum looks great.',
  coverageMessageLow: 'Drag more tasks into your week.',
  backlog: 'Backlog',
  backlogSubtitle: 'Keep tasks here until you place them into the week.',
  backlogEmpty: 'No unscheduled tasks found.',
  filterTasks: 'Filter tasks...',
  dueThisWeek: '{count} due this week',
  aiHighlights: 'AI highlights',
  aiHighlightsSubtitle: 'Top priorities suggested',
  aiHighlightsEmpty: 'Generate a plan to get ideas.',
  dragDropTipsTitle: 'Drag & drop tips',
  dragDropTips: 'Press and hold tasks for a second on phones before dragging, or tap the â€œSend to dayâ€ menu on backlog cards. Swipe the weekday cards sideways to review each day.',
  askAiDraft: 'Ask the AI to draft your week',
  goalsLabel: 'Goals (one per line)',
  goalsPlaceholder: 'Finish lab report\nReview calculus chapters\nPractise presentation',
  commitmentsLabel: 'Commitments (classes, work, etc.)',
  commitmentsPlaceholder: 'Lab on Tuesday 2pm\nFamily dinner Thursday',
  risksLabel: 'Risks / blockers',
  risksPlaceholder: 'Possible group project delays, limited evenings due to sports practice',
  generatePlanButton: 'Generate Weekly Plan (AI)',
  clearBoardButton: 'Clear Board',
  savePlanButton: 'Save Weekly Plan',
  statusGenerated: 'Weekly plan generated. Review and adjust before saving.',
  statusSaved: 'Weekly plan saved to your schedule.',
  statusCleared: 'Board cleared. Start arranging tasks again.',
  statusNothingToSave: 'Nothing to save yet. Drag tasks into the week before saving.',
  errorGenerate: 'Could not generate plan. Try again in a moment.',
  errorSave: 'Could not save plan. Please try again.',
  aiGenerationError: 'AI plan generation failed. Please try again.',
  loadingTasks: 'Loading your tasks...',
  loadError: 'Unable to load tasks. Please refresh or try again later.',
  backToDashboard: 'Back to Dashboard',
  dropTasksHere: 'Drop tasks here',
  dragTasksHere: 'Drag tasks here to keep them unplanned for now.',
  hideList: 'Hide list',
  showList: 'Show list',
  sendToDay: 'Send to day',
  chooseDay: 'Choose a day...',
  overview: 'Overview',
  metrics: 'Metrics',
  focusMinutes: 'Focus minutes',
  restBlocks: 'Rest blocks',
  stretchGoals: 'Stretch goals',
  untitledTask: 'Untitled Task',
  signInToGenerate: 'Sign in to generate an AI plan.',
  signInToSave: 'Sign in to save your weekly plan.',
  weeklyPlanNote: 'Weekly plan: {overview}',
  weeklyPlanSlot: 'Weekly plan slot',
  tasks: 'tasks',

  studyGroupsPhaseLabel: 'Phase 8 · Social Labs',
  studyGroupsHeroTitle: 'Study Groups HQ',
  studyGroupsHeroSubtitle: 'Coordinate focus sprints, celebrate wins, and keep your circle accountable.',
  studyGroupsInviteCodeLabel: 'Invite Code',
  studyGroupsStatusCreated: 'Group created! Invite your friends using the code on the right.',
  studyGroupsStatusJoin: 'Request sent! Check back for membership updates.',
  studyGroupsStatusLeft: 'You left the group',
  studyGroupsStatusPrivacySaved: 'Privacy settings saved',
  studyGroupsStatusChallengeCreated: 'Challenge added to the group',
  studyGroupsErrorLoad: 'Unable to load groups right now',
  studyGroupsErrorCreate: 'Unable to create group',
  studyGroupsErrorJoin: 'Unable to join group',
  studyGroupsErrorLeave: 'Unable to leave group',
  studyGroupsErrorPrivacy: 'Failed to update privacy',
  studyGroupsErrorChallenge: 'Unable to create challenge',
  studyGroupsErrorDetails: 'Failed to load group details',
  studyGroupsRosterLoading: 'Loading roster...',
  studyGroupsRosterEmpty: 'No members yet.',
  studyGroupsYourGroupsTitle: 'Your groups',
  studyGroupsYourGroupsLoading: 'Loading your spaces...',
  studyGroupsYourGroupsEmpty: 'You have not joined any groups yet. Create one or use an invite code below.',
  studyGroupsLaunchTitle: 'Launch a new group',
  studyGroupsNameLabel: 'Group name',
  studyGroupsNamePlaceholder: 'Night Owls Club',
  studyGroupsDescriptionLabel: 'Description',
  studyGroupsDescriptionPlaceholder: 'Weekly accountability check-ins and async focus sprints.',
  studyGroupsPrivacyLabel: 'Privacy',
  studyGroupsPrivacyPublicLabel: 'Public',
  studyGroupsPrivacyPublicHint: 'Anyone can find and join your group',
  studyGroupsPrivacyInviteLabel: 'Invite Only',
  studyGroupsPrivacyInviteHint: 'Requires the invite code to join',
  studyGroupsPrivacyPrivateLabel: 'Private',
  studyGroupsPrivacyPrivateHint: 'Owner must approve new members',
  studyGroupsAllowInvitesLabel: 'Allow members to share invite code',
  studyGroupsCreateButton: 'Create group',
  studyGroupsJoinTitle: 'Join with a code',
  studyGroupsJoinCodeLabel: 'Invite code',
  studyGroupsJoinCodePlaceholder: 'ABCD1234',
  studyGroupsJoinButton: 'Request access',
  studyGroupsActiveDescriptionFallback: 'No description yet.',
  studyGroupsRoleLabel: 'Role: {role}',
  studyGroupsStatusLabel: 'Status: {status}',
  studyGroupsPrivacyControlsTitle: 'Privacy controls',
  studyGroupsPrivacyMembersHint: 'Members can share invite code',
  studyGroupsPrivacySaveButton: 'Save controls',
  studyGroupsMembersTitle: 'Member roster',
  studyGroupsMembersLeaveButton: 'Leave group',
  studyGroupsMemberFocus: '{minutes} focus min',
  studyGroupsMemberXp: '{xp} XP',
  studyGroupsChallengesTitle: 'Group Challenges',
  studyGroupsChallengesSubtitle: 'Keep everyone aligned on a shared goal.',
  studyGroupsChallengesEmpty: 'No challenges yet. Launch the first one!',
  studyGroupsChallengesCreateTitle: 'Create challenge',
  studyGroupsChallengeTitleLabel: 'Title',
  studyGroupsChallengeXpLabel: 'XP reward',
  studyGroupsChallengeStartLabel: 'Start date',
  studyGroupsChallengeEndLabel: 'End date',
  studyGroupsChallengeDescriptionLabel: 'Description',
  studyGroupsChallengeTargetLabel: 'Focus target (minutes)',
  studyGroupsChallengeButton: 'Publish challenge',
  studyGroupsChallengeDefaultTitle: 'Deep Focus Sprint',
  studyGroupsChallengeDefaultDescription: 'Collectively hit your focus goal this week.',
  studyGroupsEmptyStateTitle: 'Create or join a group to get started.',
  studyGroupsEmptyStateSubtitle: 'You will see member rosters, controls, and challenges here once you have an active group.',

  // Group Goals & Activity
  groupGoalsTitle: 'Group Goals',
  groupGoalsEmpty: 'No goals yet. Create one to rally the team!',
  groupGoalsCreate: 'New Goal',
  groupGoalsProgress: 'Progress',
  groupGoalsContribute: 'Contribute',
  groupGoalsContributed: 'contributed',
  groupGoalsTargetLabel: 'Target',
  groupGoalsUnitTasks: 'tasks',
  groupGoalsUnitMinutes: 'minutes',
  groupGoalsUnitSessions: 'sessions',
  groupGoalsCompleted: 'Completed! 🎉',
  groupGoalsTitleLabel: 'Goal title',
  groupGoalsDescriptionLabel: 'Description (optional)',
  groupGoalsTargetDateLabel: 'Target date',
  groupGoalsTargetValueLabel: 'Target value',
  groupGoalsUnitLabel: 'Unit',
  groupActivityTitle: 'Activity',
  groupActivityEmpty: 'No activity yet',
  groupActivityGoalCreated: '{user} created a new goal: {goal}',
  groupActivityGoalProgress: '{user} contributed {amount} to {goal}',
  groupActivityGoalCompleted: '🎉 Goal completed: {goal}!',
  groupActivityMemberJoined: '{user} joined the group',
  groupActivityFocusSession: '{user} completed a focus session',
  groupActivityTaskCompleted: '{user} completed a task',

  accountabilityPhaseLabel: 'Study Buddies',
  accountabilityHeroTitle: 'Study Buddies',
  accountabilityHeroSubtitle: 'Team up with a study buddy for daily check-ins and streak tracking. 🎯',
  accountabilityShareCodeLabel: 'Your buddy code',
  accountabilityShareCodeButton: 'Copy',
  accountabilityStatusInviteSent: 'Invite sent! Share your code with your study buddy.',
  accountabilityStatusCheckIn: 'Check-in recorded! 🎉 Keep the streak alive!',
  accountabilityStatusCopied: 'Copied! Send this code to your buddy.',
  accountabilityStatusAlreadyChecked: 'Already checked in today. Come back tomorrow.',
  accountabilityErrorLoad: 'Unable to load partner links',
  accountabilityErrorInvite: 'Unable to send invite',
  accountabilityErrorUpdate: 'Unable to update invite',
  accountabilityErrorCheckIn: 'Unable to log check-in',
  accountabilityErrorClipboard: 'Clipboard blocked—copy the ID manually.',
  accountabilityInviteTitle: 'Add a Study Buddy',
  accountabilityInviteDescription: 'Share your buddy code or paste a friend\'s code below to connect.',
  accountabilityPartnerIdLabel: 'Buddy code',
  accountabilityPartnerIdPlaceholder: 'Paste their buddy code',
  accountabilitySendInviteButton: 'Send invite',
  accountabilityHowItWorksTitle: 'How it works',
  accountabilityHowItWorksStep1: 'Swap buddy codes with a trusted friend.',
  accountabilityHowItWorksStep2: 'Send an invite and wait for approval.',
  accountabilityHowItWorksStep3: 'Daily check-ins grow your shared streak! 🔥',
  accountabilityPendingTitle: 'Pending invites',
  accountabilityPendingSubtitle: 'Approve or cancel link requests.',
  accountabilityPendingLoading: 'Loading invites…',
  accountabilityPendingEmpty: 'No pending requests right now.',
  accountabilityIncomingLabel: 'Incoming from {partner}',
  accountabilityIncomingHint: 'Waiting for your response',
  accountabilityDeclineButton: 'Decline',
  accountabilityAcceptButton: 'Accept',
  accountabilityWaitingLabel: 'Waiting on {partner}',
  accountabilityWaitingHint: 'Sent {date}',
  accountabilityCancelButton: 'Cancel',
  accountabilityActiveTitle: 'Your Buddies',
  accountabilityActiveSubtitle: 'Quick check-ins keep your streaks alive! 🔥',
  accountabilityActiveEmpty: 'Your buddies will appear here once they accept your invite.',
  accountabilityPartnerLabel: 'Buddy {id}',
  accountabilityLastCheckIn: 'Last check-in: {date}',
  accountabilityStreakBadge: '{count} day streak',
  accountabilityPrivacyLabel: 'Privacy: {value}',
  accountabilityCheckInButton: 'Log check-in',
  accountabilityCheckInLocked: 'Come back tomorrow',
  accountabilityCheckInLoading: 'Logging',
  accountabilityEndLinkButton: 'End link',
  accountabilityTabMyBuddies: 'My Buddies',
  accountabilityTabAddBuddy: 'Add Buddy',
  accountabilityTabPending: 'Pending',
  accountabilityWeekProgress: "This Week's Progress",
  accountabilityEmptyTitle: 'No study buddies yet',
  accountabilityEmptySubtitle: 'Team up with a friend to 2x your motivation! Share your buddy code above to get started. 🚀',

  // Settings Modal
  settingsTitle: 'Settings',
  settingsSubtitle: 'Manage your study preferences',
  settingsLanguage: 'Language',
  settingsStudyPreferences: 'Study Preferences',
  settingsRetentionHours: 'Completed Task Retention (hours)',
  settingsWorkInterval: 'Work Interval (minutes)',
  settingsBreakInterval: 'Break Interval (minutes)',
  settingsSaveButton: 'Save Preferences',
  settingsSaved: 'Saved ✓',
  profileSectionTitle: 'Profile',
  profileFullNameLabel: 'Full name',
  profilePersonaLabel: 'Preferred nickname',
  profileTimezoneLabel: 'Timezone',
  profileBioLabel: 'Study focus / bio (optional)',
  profileSaveButton: 'Save Profile',
  profileSaved: 'Profile updated ✓',
  profileMissingName: 'Add your name so teammates recognize you.',
  profileSetupTitle: 'Tell us about you',
  profileSetupSubtitle: 'We show your name across Triyo leaderboards and study groups.',

  // Landing Page
  landingNavFeatures: 'Features',
  landingNavHowItWorks: 'How it Works',
  landingNavPricing: 'Pricing',
  landingNavFAQ: 'FAQ',
  landingNavRoadmap: 'Roadmap',
  landingNavGetStarted: 'Get Started',

  landingHeroBadge: 'AI Powered ✨',
  landingHeroTitle1: 'Your Academic Potential',
  landingHeroTitle2: 'Unlocked by AI',
  landingHeroSubtitle: "Triyo isn't just a planner. It's an intelligent Study OS that turns your tasks into quests, predicts your study time, and coaches you to better grades.",
  landingHeroCTA: 'Start Your Quest',
  landingHeroSecondaryCTA: 'See AI Magic',

  landingSocialPartner1: 'Web Summit Exhibitor',
  landingSocialPartner2: 'Built by Students',
  landingSocialPartner3: 'Powered by Supabase',
  landingSocialPartner4: 'Advanced AI Models',

  landingProblemTitle: 'The Old Way',
  landingProblemItem1: 'Overwhelmed by scattered assignments',
  landingProblemItem2: 'Guessing how long tasks will take',
  landingProblemItem3: 'Cramming before exams with no plan',
  landingProblemItem4: 'Studying alone with no motivation',

  landingSolutionTitle: 'The Triyo Way',
  landingSolutionItem1: 'AI breaks down big tasks automatically',
  landingSolutionItem2: 'Smart estimates for study duration',
  landingSolutionItem3: 'Strategic recovery plans for low grades',
  landingSolutionItem4: 'Gamified progress with XP and rewards',

  landingAITitlePrefix: 'Your Personal',
  landingAITitleSuffix: 'AI Tutor',
  landingAISubtitle: "Triyo doesn't just list your tasks. It understands them. Experience the power of an AI that actively helps you study better.",
  landingAIFeature1Title: 'Smart Task Breakdown',
  landingAIFeature1Desc: "Overwhelmed by 'Write Essay'? Triyo's AI splits it into actionable steps like 'Research', 'Outline', and 'Draft' instantly.",
  landingAIFeature2Title: 'AI Time Estimation',
  landingAIFeature2Desc: 'Stop guessing. Triyo predicts exactly how long tasks will take based on difficulty and subject, so you can plan realistically.',
  landingAIFeature3Title: 'Grade Recovery Plans',
  landingAIFeature3Desc: 'Fell behind? The AI analyzes your current grade and remaining assignments to build a mathematical path to your target.',
  landingAIFeature4Title: 'Mood-Based Coaching',
  landingAIFeature4Desc: 'Feeling stressed? Triyo adapts its advice. Tell it how you feel, and get personalized motivation to keep you going.',
  landingAIFeature5Title: 'Context-Aware Tips',
  landingAIFeature5Desc: "Stuck on a specific subject? Get instant, relevant study strategies for the exact task you're working on.",

  landingFeaturesTitle: 'Everything you need to excel',
  landingFeaturesSubtitle: 'Powerful features designed specifically for the modern student workflow.',
  landingFeaturesItem1Title: 'Command Center',
  landingFeaturesItem1Desc: 'Your entire academic life at a glance. Tasks, deadlines, and progress in one unified view.',
  landingFeaturesItem2Title: 'RPG Gamification',
  landingFeaturesItem2Desc: 'Earn XP for studying, level up your character, and maintain streaks. Make success addictive.',
  landingFeaturesItem3Title: 'Stat Tracking',
  landingFeaturesItem3Desc: "Visualize your 'character stats' (grades & focus time) to identify your strengths and weaknesses.",
  landingFeaturesItem4Title: 'Multiplayer Mode',
  landingFeaturesItem4Desc: 'Form parties (study groups), share loot (resources), and climb the global leaderboards.',
  landingFeaturesItem5Title: 'Knowledge Base',
  landingFeaturesItem5Desc: 'Organize notes, PDFs, and links for each quest (subject) in one accessible inventory.',
  landingFeaturesItem6Title: 'Focus Ability',
  landingFeaturesItem6Desc: "Activate 'Focus Mode' to block distractions and boost your productivity multiplier.",

  landingHowItWorksTitle: "How It Works",
  landingHowItWorksStep1Title: "Input Your Material",
  landingHowItWorksStep1Desc: "Simply add your tasks, exams, and syllabus.",
  landingHowItWorksStep2Title: "AI Strategy",
  landingHowItWorksStep2Desc: "Triyo builds a custom schedule and breakdown.",
  landingHowItWorksStep3Title: "Execute & Win",
  landingHowItWorksStep3Desc: "Follow the plan, earn XP, and ace your exams.",

  landingRoadmapTitle: 'Product Roadmap',
  landingRoadmapSubtitle: "See what's coming next to Triyo.",
  landingRoadmapQ1Title: 'Smart Scheduling',
  landingRoadmapQ1Item1: 'Calendar integration',
  landingRoadmapQ1Item2: 'AI conflict resolution',
  landingRoadmapQ1Item3: 'Mobile app beta',
  landingRoadmapQ2Title: 'Collaboration',
  landingRoadmapQ2Item1: 'Group study rooms',
  landingRoadmapQ2Item2: 'Shared resource libraries',
  landingRoadmapQ2Item3: 'Peer tutoring marketplace',
  landingRoadmapQ3Title: 'Advanced AI',
  landingRoadmapQ3Item1: 'Essay grading assistant',
  landingRoadmapQ3Item2: 'Voice-to-notes summary',
  landingRoadmapQ3Item3: 'Personalized learning paths',

  landingPricingTitle: 'Simple Pricing',
  landingPricingFreeTitle: 'Free Starter',
  landingPricingFreePrice: '$0',
  landingPricingFreeItem1: 'Basic Task Management',
  landingPricingFreeItem2: '3 Focus Sessions / day',
  landingPricingFreeItem3: '1 Week History',
  landingPricingFreeCTA: 'Start Free',
  landingPricingPlusTitle: 'Triyo Plus',
  landingPricingPlusPrice: '$5',
  landingPricingPlusItem1: 'Unlimited AI Study Plans',
  landingPricingPlusItem2: 'Unlimited Focus Sessions',
  landingPricingPlusItem3: 'Advanced Analytics',
  landingPricingPlusItem4: 'Cloud Sync & Backups',
  landingPricingJoinWaitlist: 'Join Waitlist',
  landingPricingJoinSuccess: 'You are on the list! 🚀',
  landingPricingComingSoon: 'COMING SOON',
  landingPricingEmailPlaceholder: 'Enter your email',

  landingFAQTitle: 'Frequently Asked Questions',
  landingFAQ1Q: 'Is Triyo really free?',
  landingFAQ1A: 'Yes! Our core features are completely free for students. We plan to introduce premium features for power users later.',
  landingFAQ2Q: 'Can I use it on my phone?',
  landingFAQ2A: 'Triyo is a fully responsive web app that works great on mobile browsers. A native mobile app is on our roadmap for 2026.',
  landingFAQ3Q: 'How does the AI planning work?',
  landingFAQ3A: 'We use advanced AI models to analyze your tasks and deadlines, then suggest an optimal schedule based on your study habits.',
  landingFAQ4Q: 'Is my data secure?',
  landingFAQ4A: 'Absolutely. We use Supabase for enterprise-grade security and never share your personal data with third parties.',

  landingFooterTagline: 'The AI-powered operating system for your academic success. Built by students, for students.',
  landingFooterProduct: 'Product',
  landingFooterLegal: 'Legal',
  landingFooterPrivacy: 'Privacy Policy',
  landingFooterTerms: 'Terms of Service',
  // Landing Page - New Features
  landingWeeklyTitle: "Smart Weekly Planner",
  landingWeeklyDesc: "Stop stressing about your schedule. Drag, drop, and let AI auto-schedule your study sessions around your life. Includes a backlog for unscheduled tasks.",
  landingWeeklyFeature1: "AI Auto-Schedule",
  landingWeeklyFeature2: "Drag & Drop Interface",
  landingWeeklyFeature3: "Smart Backlog",

  landingHeroBullet1: "Auto-plan your week",
  landingHeroBullet2: "Predict study time",
  landingHeroBullet3: "Turn tasks into focus sessions",
  landingCTAStartFree: "Get Started Free",
  landingCTAWatchDemo: "Watch Demo",

  landingProofStudents: "Built by students",
  landingProofSummit: "Web Summit exhibitor",
  landingProofPrivacy: "Privacy-first design",
  landingProofAI: "AI assisted planning",
  landingProofSupabase: "Supabase powered",

  landingComparisonTitle: "Study Smarter, Not Harder",
  landingComparisonOldWay: "The Manual Way",
  landingComparisonNewWay: "The Triyo Way",

  landingFinalCTATitle: "Start planning smarter today",
  landingFinalCTASubtitle: "Free to start. No credit card required.",

  landingGamificationTitle: "Level Up Your Learning",
  landingGamificationDesc: "Turn studying into a game. Complete daily quests, earn XP, and hatch your own AI pet companion. Stay motivated with streaks and leaderboards.",
  landingGamificationFeature1: "Hatch AI Pets",
  landingGamificationFeature2: "Daily Quests & XP",
  landingGamificationFeature3: "Global Leaderboards",

  landingGradesTitle: "Grade Savior & Calculator",
  landingGradesDesc: "Know exactly where you stand. Calculate your GPA and get AI-generated 'Recovery Plans' to maximize your scores before finals.",
  landingGradesFeature1: "GPA Calculator",
  landingGradesFeature2: "AI Recovery Plans",
  landingGradesFeature3: "What-If Scenarios",

  landingGroupsTitle: "Collaborative Study Groups",
  landingGroupsDesc: "Don't study alone. Join subject-specific groups, share resources, and keep each other accountable with built-in chat and file sharing.",
  landingGroupsFeature1: "Real-time Chat",
  landingGroupsFeature2: "Resource Sharing",
  landingGroupsFeature3: "Accountability Tools",

  landingFooterContact: 'Contact',
  landingFooterRights: 'All rights reserved.',

  landingStudentsTitle: 'For Students',
  landingStudentsDesc: 'Master your coursework and reclaim your free time.',
  landingStudentsItem1: 'Never miss a deadline',
  landingStudentsItem2: 'Boost your GPA',
  landingStudentsItem3: 'Reduce exam anxiety',
  landingStudentsCTA: 'Learn more',

  landingUniTitle: 'For Universities',
  landingUniDesc: 'Empower your student body with modern tools for success.',
  landingUniItem1: 'Improve retention rates',
  landingUniItem2: 'Analytics on student performance',
  landingUniItem3: 'Digital campus integration',
  landingUniCTA: 'Partner with us',

  // Feature Reveal Section
  landingRevealSectionTitle: "Unlock Your",
  landingRevealSectionHighlight: "Full Potential",
  landingRevealDailyTitle: "Daily Focus",
  landingRevealDailyDesc: "Stay on track with daily tasks.",
  landingRevealWeeklyTitle: "Weekly Plan",
  landingRevealWeeklyDesc: "Visualize your week ahead.",
  landingRevealGradesTitle: "Grade Tracking",
  landingRevealGradesDesc: "Monitor your academic performance.",
  landingRevealAITitle: "AI Assistance",
  landingRevealAIDesc: "Get help when you need it.",
  landingAIChatQuestion: "How do I solve this?",
  landingAIChatAnswer: "Here is the solution steps...",
  landingRevealPhysicsTitle: "Subject Mastery",
  landingRevealPhysicsDesc: "Deep dive into your subjects.",
  landingRevealConnectTitle: "Connect & Learn",
  landingRevealConnectDesc: "Join study groups and learn together.",

  // Beta Banner
  betaBannerPrefix: 'Beta:',
  betaBannerText: 'Active development.',
  betaBannerFeedback: 'Feedback:',

  // Grade Tracking Section (Restored)
  landingGradeTrackBadge: "Grade Tracking",
  landingGradeTrackTitle: "Know exactly where allowed stands.",
  landingGradeTrackSubtitle: "Visualize your academic performance in real-time. Set target grades, track assignments, and know exactly what you need to score to ace the class.",
  landingGradeTrackFeature1: "Weighted Average Calculation",
  landingGradeTrackFeature2: "Recovery Plans for Low Grades",
  landingGradeTrackCard1Class: "Advanced Calculus II",
  landingGradeTrackCard1Meta: "MATH 202 • 4 Credits",
  landingGradeTrackCard1Grade: "A",
  landingGradeTrackCard2Class: "Physics 101",
  landingGradeTrackCard2Meta: "PHYS 101 • 3 Credits",
  landingGradeTrackCard2Grade: "B+",
  landingGradeTrackCard2MetaRising: "Rising",
  landingGradeTrackCard3Class: "Intro to CS",
  landingGradeTrackCard3Meta: "CS 101 • 4 Credits",
  landingGradeTrackCard3Grade: "A-",
  landingGradeProgress: "Progress to Goal",
  landingGradeTrackFloatBadge: "GPA",

  // Auth Page New
  authPageTitleSignUp: 'Create an account',
  authPageTitleSignIn: 'Welcome back',
  authPageSubtitleSignUp: 'Start your journey to better grades today.',
  authPageSubtitleSignIn: 'Please enter your details to sign in.',
  authPageGoogleContinue: 'Continue with Google',
  authPageOrEmail: 'Or with email',
  authPageEmailLabel: 'Email Address',
  authPagePasswordLabel: 'Password',
  authPageForgotPassword: 'Forgot password?',
  authPageButtonSignUp: 'Create Account',
  authPageButtonSignIn: 'Sign In',
  authPageButtonLoadingSignUp: 'Creating Account...',
  authPageButtonLoadingSignIn: 'Signing in...',
  authPageSwitchAccountQuestionSignUp: 'Already have an account?',
  authPageSwitchAccountQuestionSignIn: "Don't have an account?",
  authPageSwitchActionSignUp: 'Sign in instead',
  authPageSwitchActionSignIn: 'Create free account',
  authPageTOSPrefix: 'By continuing, you agree to Triyo\'s',
  authPageTOSLink: 'Terms of Service',
  authPagePrivacyLink: 'Privacy Policy',
  authPageSideTitle1: 'Master your studies with',
  authPageSideTitle2: 'AI-powered focus',
  authPageSideSubtitle: 'Join students who are organizing their academic life, boosting their GPA, and reducing stress with Triyo.',
  authPageSideFeature1: 'Free for students',
  authPageSideFeature2: 'No credit card required',
  authPageSuccessSignUp: '✅ Account created! You can now sign in.',
  authPageSuccessSignUpConfirm: '✅ Account created! Please check your email to confirm your account before signing in.',
  and: 'and',

  // Forgot Password Page
  forgotPassTitle: 'Reset Password',
  forgotPassSubtitle: "Enter your email address and we'll send you a link to reset your password.",
  forgotPassLabelEmail: 'Email Address',
  forgotPassButtonSend: 'Send Reset Link',
  forgotPassButtonSending: 'Sending Link...',
  forgotPassBackToLogin: 'Back to login',
  forgotPassSideTitle1: "Don't worry,",
  forgotPassSideTitle2: 'we got you covered.',
  forgotPassSuccess: 'Check your email for a password reset link.',
  forgotPassErrorRateLimit: 'Too many requests. Please try again in a minute.',
  forgotPassErrorGeneric: 'Failed to send reset email.',

  // Reset Password Page
  resetPassTitle: 'Set New Password',
  resetPassSubtitle: 'Please enter your new password below.',
  resetPassLabelPass: 'New Password',
  resetPassLabelConfirm: 'Confirm Password',
  resetPassButtonUpdate: 'Update Password',
  resetPassButtonUpdating: 'Updating...',
  resetPassSuccess: 'Password updated successfully! Redirecting...',
  resetPassErrorMismatch: 'Passwords do not match.',
  resetPassErrorLength: 'Password must be at least 6 characters.',
  resetPassErrorInvalidLink: 'Invalid or expired reset link. Please try again.',
  resetPassErrorGeneric: 'Failed to update password.',
  resetPassRequestNewLink: 'Request a new link',

  // Legal Modal
  legalModalIUnderstand: 'I Understand',
  legalModalPrint: 'Print',
  legalModalLastUpdated: 'Last updated',
  legalModalQuickNav: 'Quick Navigation',
  legalModalSections: 'sections',
  legalModalPrivacyTitle: 'Privacy Policy',
  legalModalTermsTitle: 'Terms of Service',

  // Quota Indicator
  quotaUnlimited: 'Unlimited',
  quotaRemaining: 'Remaining today',
  quotaAiTips: 'AI Tips',
  quotaSmartTasks: 'Smart Tasks',
  quotaUpgrade: 'Upgrade',
  quotaLimitReached: 'Daily limit reached',
  quotaTodayFree: 'free uses today',

  // Calendar Export
  calendarExport: 'Export',
  calendarExportTitle: 'Export Tasks',
  calendarExportTasksCount: 'active tasks',
  calendarDownloadICS: 'Download .ics file',
  calendarICSHint: 'Works with any calendar app',
  calendarAddGoogle: 'Add to Google Calendar',
  calendarAddOutlook: 'Add to Outlook',
  calendarOpenNew: 'Opens in new tab',
  calendarExportAll: 'Export All',
  calendarExportDownloaded: 'Exported!',
  calendarExporting: 'Opening',
  calendarPopupNote: 'Allow pop-ups for this site. Each task opens pre-filled — just click Save.',
  calendarExportAllHint: 'Add all tasks directly',

  // Project Teams Page
  projectTeamsLabel: 'Project Teams',
  projectTeamsTitle: 'Your Projects',
  projectTeamsSubtitle: 'Collaborate with your team on shared tasks and goals.',
  projectTeamsNewProject: 'New Project',
  projectTeamsJoin: 'Join',
  projectTeamsMyProjects: 'My Projects',
  projectTeamsNoProjects: 'No projects yet.',
  projectTeamsSelectProject: 'Select a Project',
  projectTeamsSelectProjectHint: 'Choose a project from the list or create a new one.',
  projectTeamsCreateTitle: 'Create New Project',
  projectTeamsProjectName: 'Project Name',
  projectTeamsProjectNamePlaceholder: 'e.g., Software Engineering Final',
  projectTeamsDescriptionOptional: 'Description (optional)',
  projectTeamsDescriptionPlaceholder: 'What is this project about?',
  projectTeamsCancel: 'Cancel',
  projectTeamsCreateButton: 'Create Project',
  projectTeamsJoinTitle: 'Join a Project',
  projectTeamsInviteCodeLabel: 'Invite Code',
  projectTeamsEnterCode: 'ENTER CODE',
  projectTeamsJoinButton: 'Join Project',
  projectTeamsInviteMember: 'Invite Member',
  projectTeamsLeaveProject: 'Leave Project',
  projectTeamsNoDescription: 'No description',
  projectTeamsInviteTitle: 'Invite Team Members',
  projectTeamsInviteSubtitle: 'Share this code or link to invite others',
  projectTeamsInviteCode: 'Invite Code',
  projectTeamsShareableLink: 'Shareable Link',
  projectTeamsCopyLink: 'Copy Link',
  projectTeamsNoInviteCode: 'No invite code available for this project.',
  projectTeamsInvitesDisabled: 'The project may have invites disabled.',
  projectTeamsClose: 'Close',
  projectTeamsProjectBoard: 'Project Board',
  projectTeamsAddTask: 'Add Task',
  projectTeamsToDo: 'To Do',
  projectTeamsInProgress: 'In Progress',
  projectTeamsDone: 'Done',
  projectTeamsNoTasks: 'No tasks',
  projectTeamsTeamMembers: 'Team Members',
  projectTeamsNoMembers: 'No members yet',
  projectTeamsTasksDone: 'Tasks Done',
  projectTeamsAssignTo: 'Assign to',
  projectTeamsNoTeamMembers: 'No team members',
  projectTeamsAnyone: 'Anyone with this code can join',
  projectTeamsOwner: 'Owner',
  projectTeamsMember: 'Member',

  // AI Task Prompt
  aiPromptPlaceholder: 'What do you need to study? e.g. "Math exam Thursday, CS project next week"',
  aiNoTasksFound: "I couldn't find any tasks in your message. Try something like \"Math exam on Thursday\"",
  aiParseError: 'Something went wrong. Please try again.',
  aiTasksAdded: 'Tasks added to your board!',
  aiFoundTask: '1 task found',
  aiFoundTasks: '{count} tasks found',
  aiAddAll: 'Add All',
  tryAgain: 'Try again',
};


export const arabicTranslations: Translations = {
  greetingMorning: 'صباح الخير',
  greetingAfternoon: 'مساء الخير',
  greetingEvening: 'مساء الخير',
  todaysFocus: 'لنجعل اليوم مثمراً!',
  todaysFocusHeader: "تركيز اليوم",
  todaysFocusEmpty: "لا توجد مهام تركيز مستحقة اليوم. أنت في السليم!",
  todaysFocusAddButton: "إضافة مهمة",
  todaysFocusStartButton: "ابدأ التركيز",
  todaysFocusStartSession: "بدء جلسة التركيز",
  dayStreak: 'أيام متتالية',
  streakDays: 'يوم',
  streakTooltip: 'سلسلة الدراسة اليومية',
  levelPrefix: 'مستوى',
  levelTooltip: 'مستواك الحالي',
  addTask: 'أضف مهمة',
  student: 'طالب',
  filterAllSubjects: 'كل المواد',
  filterAllPriorities: 'كل الأولويات',

  // Landing Page Refactor
  landingStickyScrollItem1Title: "الفوضى والإرهاق",
  landingStickyScrollItem1Desc: "ملاحظات في كل مكان، مواعيد فائتة، وقلق مستمر من 'ماذا أذاكر الآن؟'",
  landingStickyScrollBadgeOldWay: "الطريقة القديمة",
  landingStickyScrollBadgeNoStructure: "فوضى",
  landingStickyScrollBadgeCramming: "حشو",
  landingStickyScrollBadgeBurnout: "احتراق",
  landingStickyScrollItem2Title: "نظام تشغيلك الذكي",
  landingStickyScrollItem2Desc: "جدولة ذكية تتكيف مع طاقتك. حوّل المهام إلى خطوات واضحة ومحددة.",
  landingStickyScrollBadgeTriyoWay: "طريقة تريو",
  landingStickyScrollBadgeAutoSchedule: "جدولة تلقائية",
  landingStickyScrollBadgeGradePred: "توقع الدرجات",
  landingStickyScrollBadgeSmartBreaks: "راحات ذكية",
  landingStickyScrollItem3Title: "استعد وقتك",
  landingStickyScrollItem3Desc: "وفّر أكثر من 10 ساعات أسبوعياً من التخطيط والقلق. ركّز على التعلم، واترك التنظيم لنا.",
  landingStickyScrollBadgeSaved: "وفرت / أسبوع",
  landingStickyScrollBadgeEfficiency: "كفاءة التركيز",

  landingStackCard1Title: "الطريقة القديمة",
  landingStackCard1Desc: "ملاحظات مبعثرة، مواعيد فائتة، وحشو في اللحظة الأخيرة.",
  landingStackCard1List1: "ملاحظات مبعثرة",
  landingStackCard1List2: "مواعيد فائتة",
  landingStackCard1List3: "حشو",

  landingStackCard2Title: "نظام تريو",
  landingStackCard2Desc: "نظام تشغيل كامل لحياتك الأكاديمية.",
  landingStackCard2List1: "جدولة تلقائية",
  landingStackCard2List2: "نظام المهام",
  landingStackCard2List3: "توقع الدرجات",

  landingStackCard3Title: "النجاح الأكاديمي",
  landingStackCard3Desc: "نتائج ملموسة في فصل دراسي واحد فقط.",
  landingStackCard3Stat: "زيادة المعدل +0.5",

  landingSocialProofTitle: "مدعوم بالتميز",

  featureShowcasePlannerTitle: "المخطط الأسبوعي الذكي",
  featureShowcasePlannerDesc: "جدولة تلقائية للمهام بمنطق الذكاء الاصطناعي. اسحب وأفلت ودع النظام يحسن أسبوعك.",
  featureShowcaseGamificationTitle: "التعلم باللعب",
  featureShowcaseGamificationDesc: "اكسب نقاط خبرة لكل جلسة دراسية. ارتق بالمستوى وافتح المكافآت وتنافس في قوائم المتصدرين.",
  featureShowcaseGradesTitle: "منقذ الدرجات",
  featureShowcaseGradesDesc: "تخيل أداءك الأكاديمي. احسب سيناريوهات 'ماذا لو' لإنقاذ معدلك التراكمي.",
  featureShowcaseGroupsTitle: "مجموعات تعاونية",
  featureShowcaseGroupsDesc: "لا تدرس وحدك. شارك المصادر ودردش مع الزملاء واغز المواد معاً.",

  featureShowcaseAitutorTitle: "المعلم الذكي",
  featureShowcaseAitutorDesc: "عالق في مسألة؟ احصل على توجيه سقراطي فوري، وليس مجرد إجابات.",
  featureShowcaseKanbanTitle: "إدارة المهام",
  featureShowcaseKanbanDesc: "نظم مهامك باستخدام عرض اللوحة، والمهام الفرعية، وعلامات الأولوية.",
  featureShowcasePetTitle: "رفيق الدراسة",
  featureShowcasePetDesc: "احصل على حيوان أليف ذكي ينمو مع دراستك. حافظ على سعادته بالاستمرار!",
  featureShowcaseTimerTitle: "مؤقت التركيز",
  featureShowcaseTimerDesc: "مؤقت بومودورو قابل للتخصيص مع وضع التركيز العميق والأصوات المحيطة.",
  featureShowcaseLeaderboardTitle: "لوحات الصدارة",
  featureShowcaseLeaderboardDesc: "نافس أصدقائك أو العالم. اكسب الشارات وتسلق المراتب.",
  featureShowcaseWellnessTitle: "فحوصات العافية",
  featureShowcaseWellnessDesc: "تتبع حالتك المزاجية وطاقتك. سنقترح فترات راحة عندما تشعر بالاحتراق.",
  featureShowcaseAnalyticsTitle: "تحليلات مفصلة",
  featureShowcaseAnalyticsDesc: "رؤى بصرية حول ساعات الإنتاجية القصوى وإتقان المواد.",
  featureShowcaseStudyCompanionTitle: "رفيق الدراسة",
  featureShowcaseStudyCompanionDesc: "أنفس حيوانك الأليف المدعوم بالذكاء الاصطناعي الذي ينمو أثناء دراستك.",
  featureShowcaseFocusModeTitle: "وضع التركيز",
  featureShowcaseFocusModeDesc: "جلسات تركيز عميق مع أصوات محيطة وقفل المهام.",
  featureShowcaseGodRaysTitle: "أجواء محيطة",
  featureShowcaseGodRaysDesc: "توهجات خلفية غامرة تتحول مع مزاجك الدراسي.",
  featureCatAcademics: "الدراسة الأساسية",
  featureCatGamification: "اللعب والتركيز",
  featureCatSocial: "اجتماعي وصحي",

  landingAITutorTitle: "المعلم الذكي",
  landingAITutorDesc: "إجابات فورية، شروحات مبسطة، وتوجيه سقراطي لفهم أعمق.",

  // Menu
  menuDashboard: 'لوحة التحكم',
  menuStudyGroups: 'مجموعات الدراسة',
  menuLeaderboards: 'لوحة المتصدرين',
  menuAccountability: 'رفاق الدراسة',
  menuGrades: 'الدرجات',
  menuWeeklyPlan: 'الخطة الأسبوعية',
  menuDailyPlan: 'الخطة اليومية',
  menuRewards: 'المكافآت',
  menuAnalytics: 'التحليلات',
  menuSettings: 'الإعدادات',
  logout: 'تسجيل الخروج',

  // Leaderboards
  leaderboardsSeasonLabel: 'الموسم الاجتماعي',
  leaderboardsHeroTitle: 'لوحة المتصدرين والزخم',
  leaderboardsHeroSubtitle: 'تتبع أداء فريقك واحتفل بالسلاسل داخل مجتمع ماي ستدي ديسك.',
  leaderboardsHeroMyRank: 'ترتيبك العالمي',
  leaderboardsGroupTitle: 'لوحة مجموعات الدراسة',
  leaderboardsGroupSubtitle: 'تصنيفات نقاط الخبرة لكل مجموعة تنتمي إليها.',
  leaderboardsLoading: '...جاري مزامنة إحصاءات المجموعات',
  leaderboardsJoinGroup: 'انضم إلى مجموعة دراسة لفتح لوحة المتصدرين المشتركة.',
  leaderboardsGroupDescriptionFallback: 'ارفع سقف أهدافك وابقَ على قدر المسؤولية.',
  leaderboardsMembersBadge: '{count} عضو',
  leaderboardsTableRank: 'الترتيب',
  leaderboardsTableMember: 'العضو',
  leaderboardsTableXP: 'نقاط XP',
  leaderboardsTableFocusMinutes: 'دقائق التركيز',
  leaderboardsTableStreak: 'السلسلة',
  leaderboardsTableEmpty: 'لا يوجد تقدم بعد - ابدأ دفعة تركيز!',
  leaderboardsGlobalTitle: 'لوحة XP العالمية',
  leaderboardsGlobalSubtitle: 'أفضل المؤدين في المنصة بأكملها.',
  leaderboardsGlobalEmpty: 'لا توجد إحصاءات عالمية بعد. أكمل تحدياً للانضمام إلى اللوحة.',
  leaderboardsGlobalEntryMeta: '{focusMinutes} دقيقة تركيز | سلسلة {streakDays} أيام',
  leaderboardsMomentumTitle: 'نصائح الزخم',
  leaderboardsMomentumTip1: 'راكم مكاسب يومية صغيرة - نقاط XP تتضاعف أسرع مما تتخيل.',
  leaderboardsMomentumTip2: 'استخدم التحديات المشتركة لإبقاء الجميع متزامنين كل أسبوع.',
  leaderboardsMomentumTip3: 'احتفل بمحطات السلسلة علناً لرفع المعنويات.',
  leaderboardsSparkTitle: 'تحتاج المزيد من الحماس؟',
  leaderboardsSparkSubtitle: 'قريباً: مكافآت موسمية تتجدد كل شهر. ترقب!',
  leaderboardsLoadError: 'تعذر تحميل لوحة المتصدرين حالياً.',

  // Analytics
  analyticsTitle: 'تحليلات الدراسة',
  analyticsBackToDashboard: 'العودة إلى لوحة التحكم',
  analyticsRangeLabel: 'المدى',
  analyticsRange14: 'آخر 14 يوماً',
  analyticsRange30: 'آخر 30 يوماً',
  analyticsRefresh: 'تحديث البيانات',
  analyticsFocusMinutesHeading: 'دقائق التركيز لكل يوم',
  analyticsSubjectHeading: 'دقائق التركيز حسب المادة',
  analyticsSubjectEmpty: 'لا توجد جلسات تركيز مرتبطة بالمواد حتى الآن.',
  analyticsTaskTableHeading: 'ملخص التركيز لكل مهمة',
  analyticsTaskLabel: 'المهمة',
  analyticsSubjectLabel: 'المادة',
  analyticsMinutesLabel: 'الدقائق',
  analyticsNoSessions: 'لا توجد جلسات تركيز بعد. ابدأ مؤقت التركيز لرؤية التحليلات.',
  analyticsLoading: 'جاري تحميل التحليلات...',
  analyticsLoadError: 'تعذّر تحميل التحليلات حالياً. يرجى التحديث.',
  analyticsUnknownSubject: 'أخرى / غير محددة',
  analyticsUnknownTask: 'مهمة بدون اسم',
  analyticsMinutesSuffix: '{value} دقيقة',

  // Stats
  totalTasks: 'كل المهام',
  toDo: 'للقيام به',
  studying: 'جاري المذاكرة',
  done: 'تم الإنجاز',

  // Kanban Columns
  toStudy: 'للمذاكرة',
  studyingNow: 'جاري المذاكرة',
  review: 'للمراجعة',
  completed: 'تم الإنجاز',
  kanbanClearAll: 'حذف الكل',
  kanbanEmptyColumn: 'لا توجد مهام',
  kanbanEmptyToStudy: 'أضف مهمة للبدء! 📚',
  kanbanEmptyStudying: 'اسحب مهمة هنا أثناء الدراسة 💪',
  kanbanEmptyReview: 'المهام للمراجعة ستظهر هنا 🔍',
  kanbanEmptyDone: 'أكمل المهام للاحتفال هنا! 🎉',

  socialStudyGroupsTitle: 'مجموعات الدراسة',
  socialStudyGroupsSubtitleDefault: 'إعدادات الخصوصية جاهزة للتعديل',
  socialStudyGroupsSubtitlePending: '{count} بانتظار الموافقة',
  socialStudyGroupsButton: 'إدارة المجموعات',
  socialLeaderboardsTitle: 'لوحة المتصدرين',
  dashboardWorkspace: 'مساحة العمل',
  socialLeaderboardsValueCTA: 'انضم إلى الترتيب',
  socialLeaderboardsSubtitleRanked: 'مركزك العالمي الحالي',
  socialLeaderboardsSubtitleCTA: 'أكمل التحديات للدخول ضمن أفضل 50',
  socialLeaderboardsButton: 'عرض لوحة المتصدرين',
  socialAccountabilityTitle: 'رفاق الدراسة',
  socialAccountabilitySubtitlePending: '{count} طلبات رفقة',
  socialAccountabilitySubtitleDefault: 'لا توجد دعوات رفقة معلقة',
  socialAccountabilityButton: 'عرض الرفاق',

  // Search & Filters
  searchPlaceholder: '...بحث في الملاحظات',
  allSubjects: 'كل المواد',
  allPriorities: 'كل الأولويات',

  // Task Card
  priority: 'الأولوية',
  dueDate: 'الموعد',
  delete: 'حذف',
  edit: 'تعديل',
  save: 'حفظ',
  cancel: 'إلغاء',
  startFocus: 'بدء التركيز',

  // New Task Modal
  createTask: 'إنشاء مهمة جديدة',
  editTask: 'تعديل المهمة',
  taskTitle: 'عنوان المهمة',
  taskTitlePlaceholder: 'مثال: المذاكرة لامتحان الرياضيات',
  description: 'الوصف',
  descriptionPlaceholder: '...أضف تفاصيل عن هذه المهمة',
  subject: 'المادة',
  dueDateTime: 'التاريخ والوقت',
  status: 'الحالة',
  newStudyTask: 'مهمة دراسية جديدة',
  whatToStudy: 'ماذا تريد أن تذاكر؟',
  detailsNotes: 'التفاصيل/ملاحظات',
  checklist: 'قائمة المهام',
  addStep: '...أضف خطوة',
  resources: 'الموارد',
  pasteURL: '...الصق الرابط',
  pinToBoard: 'تثبيت في اللوحة',

  // Priority Levels
  high: 'عالية',
  medium: 'متوسطة',
  low: 'منخفضة',

  // Subjects
  math: 'رياضيات',
  cs: 'علوم الحاسب',
  science: 'علوم',
  history: 'تاريخ',
  language: 'لغة',
  other: 'أخرى',

  // Auth Page
  welcomeBack: 'مرحباً بعودتك',
  loginSubtitle: 'سجّل الدخول إلى تريو',
  signUp: 'إنشاء حساب',
  signUpSubtitle: 'ابدأ في تنظيم دراستك',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  loginButton: 'تسجيل الدخول',
  signUpButton: 'إنشاء حساب',
  switchToSignUp: 'ليس لديك حساب؟ سجل الآن',
  switchToLogin: 'لديك حساب؟ سجل الدخول',
  magicLinkSent: 'تم إرسال رابط التسجيل!',
  checkEmail: 'تحقق من بريدك الإلكتروني للحصول على رابط الدخول',

  // Welcome Spotlight
  welcomeSpotlightTag: 'مساحتك الذكية للدراسة',
  welcomeTitle: 'مرحباً بك في تريو',
  welcomeSubtitle: 'خطط بذكاء، ركّز بعمق، وانضم إلى مجتمع مذاكرة إيجابي.',
  welcomeFeaturePlanLabel: 'خطط بوضوح',
  welcomeFeaturePlanDetail: 'حوّل المهام إلى خريطة دراسة أسبوعية مع اقتراحات الذكاء الاصطناعي.',
  welcomeFeatureFocusLabel: 'ابقَ في تركيز عميق',
  welcomeFeatureFocusDetail: 'شغّل جلسات بومودورو وسجّل دقائق التركيز الحقيقية.',
  welcomeFeatureCommunityLabel: 'تعلّم مع الآخرين',
  welcomeFeatureCommunityDetail: 'أنشئ مجموعات دراسة، تحديات، وشركاء مساءلة.',
  welcomeFeatureRewardsLabel: 'طوّر عاداتك',
  welcomeFeatureRewardsDetail: 'اكسب نقاط XP وشارات السلسلة وتذكيرات لطيفة للاستمرارية.',
  welcomeCTA: 'لنبدأ الدراسة',
  welcomeSkip: 'لاحقاً',
  welcomeAnimationAlt: 'أيقونات مضيئة تشرح التخطيط والتركيز والمجتمع',

  // Messages
  deleteConfirm: 'هل أنت متأكد من حذف هذه المهمة؟',
  emptySlot: 'فارغ',
  loadingDesk: '...جاري تحميل مكتبك',

  // Focus Timer
  focusMode: 'وضع التركيز',
  focusTime: 'وقت التركيز',
  breakTime: 'وقت الاستراحة',
  work: 'عمل',
  break: 'استراحة',
  minutes: 'دقيقة',
  start: 'بدء',
  pause: 'إيقاف مؤقت',
  resume: 'استئناف',
  finish: 'إنهاء',
  finishSession: 'سجل التركيز',
  finishAndComplete: 'أكمل المهمة',
  closeFocusTimerAria: 'إغلاق مؤقت التركيز',
  startTimerAria: 'بدء المؤقت',
  pauseTimerAria: 'إيقاف المؤقت مؤقتاً',
  resetIntervalAria: 'إعادة تعيين المدة الحالية',
  logFocusButtonTitle: 'يسجل وقت التركيز بدون إنهاء المهمة',
  completeTaskButtonTitle: 'يكمل المهمة ويسجل وقت التركيز (إذا كان دقيقة واحدة أو أكثر)',
  focusSessionHint: 'يتم حفظ وقت التركيز بعد الوصول إلى دقيقة واحدة على الأقل. استخدم "سجل التركيز" لحفظ التقدم فقط؛ "أكمل المهمة" ينهي المهمة ويحدّث سلسلتك.',
  breakSuggestionMessage: 'جلسة تركيز رائعة! هل أنت جاهز لاستراحة مدتها {minutes} دقيقة؟',
  breakSuggestionStart: 'ابدأ الاستراحة',
  breakSuggestionSkip: 'تخطي',
  focusSummaryTitle: 'إجمالي وقت التركيز لهذه الجلسة',
  breakSummaryTitle: 'إجمالي وقت الاستراحة لهذه الجلسة',
  logFocusAria: 'تسجيل وقت التركيز',
  completeTaskAria: 'إنهاء المهمة وتسجيل وقت التركيز',
  switchToWorkAria: 'التحويل إلى فترة العمل',
  switchToBreakAria: 'التحويل إلى فترة الاستراحة',

  // AI Planner
  dailyPlanTitle: 'خطة اليوم بالذكاء الاصطناعي',
  dailyPlanButton: 'أنشئ خطة اليوم (ذكاء اصطناعي)',
  dailyPlanSubtitle: 'حوّل مهامك إلى جدول يومي واقعي.',
  dailyPlanEmpty: 'لا توجد خطة حتى الآن. اضغط الزر لرسم يومك.',
  dailyPlanLoading: 'جاري إعداد جدولك بالذكاء الاصطناعي...',
  dailyPlanError: 'تعذر إنشاء الخطة. حاول مرة أخرى لاحقاً.',
  dailyPlanReady: 'خطة اليوم جاهزة الآن.',
  dailyPlanHabits: 'عادات مقترحة',
  dailyPlanRisks: 'تنبيهات مهمة',
  dailyPlanReflection: 'سؤال للتفكر',
  dailyPlanBlocks: 'فترات التركيز',
  dailyPlanLogin: 'سجّل الدخول لإنشاء خطة بالذكاء الاصطناعي.',
  dailyPlanNoTasks: 'أضف مهمة مفتوحة واحدة على الأقل لإنشاء الخطة.',

  // Rewards & Gamification
  rewardsTitle: 'مكافآتك الدراسية',
  rewardsRefreshHint: 'يتم التحديث عند انتهاء أي جلسة تركيز',
  rewardsCurrentLevelLabel: 'المستوى الحالي',
  rewardsTotalXpLabel: 'إجمالي نقاط الخبرة',
  rewardsProgressSummary: '{current} / {span} نقطة خبرة في هذا المستوى · متبق {next} نقطة للمستوى التالي',
  rewardsLongestFocusLabel: 'أطول مدة تركيز',
  rewardsLongestFocusHint: 'استهدف 60 دقيقة أو أكثر لتحصل على شارات إضافية',
  rewardsAchievementsHeading: 'الإنجازات',
  rewardsLevelLabel: 'المستوى {level}',
  rewardsLoginRequired: 'سجّل الدخول لعرض تقدّم مكافآتك.',
  rewardsLoadError: 'تعذّر تحميل تقدم المكافآت حالياً. يرجى التحديث.',
  rewardsErrorGeneric: 'تم حفظ وقت تركيزك لكن تعذّر تحديث المكافآت. حاول لاحقاً.',
  rewardsErrorMissingColumns: 'تم إيقاف المكافآت لأن جدول study_stats يفتقد أعمدة xp_total/level الجديدة. شغّل أحدث ترقية لـ Supabase ثم أعد المحاولة.',
  rewardsErrorSchema: 'تعذّر تحديث المكافآت بسبب ذاكرة مخطط Supabase القديمة. أعد تشغيل ترقية study_stats أو حدّث تعريف الجدول.',
  rewardsAchievementFirstFocusTitle: 'أول تركيز!',
  rewardsAchievementFirstFocusDescription: 'سجّل دقيقة تركيز واحدة على الأقل.',
  rewardsAchievementStreak3Title: 'بطل عطلة نهاية الأسبوع',
  rewardsAchievementStreak3Description: 'حافظ على سلسلة من 3 أيام.',
  rewardsAchievementStreak7Title: 'بطل الاستمرارية',
  rewardsAchievementStreak7Description: 'احفظ سلسلتك لمدة أسبوع كامل.',
  rewardsAchievementHourTitle: 'ساعة العمل العميق',
  rewardsAchievementHourDescription: 'ابقَ في جلسة تركيز واحدة لمدة 60 دقيقة.',
  rewardsAchievementDailyDoubleTitle: 'الضعف اليومي',
  rewardsAchievementDailyDoubleDescription: 'اجمع 120 دقيقة تركيز في يوم واحد.',
  rewardsAchievementLevel5Title: 'المستوى الخامس!',
  rewardsAchievementLevel5Description: 'الوصول إلى المستوى 5 إنجاز يستحق الفخر!',
  rewardsAchievementLevelReachedTitle: 'تم بلوغ المستوى {level}',
  rewardsAchievementLevelReachedDescription: 'عملك الجاد يؤتي ثماره—استمتع بمكافآت الترقية!',
  xpLabelSingular: 'نقطة خبرة واحدة',
  xpLabelPlural: '{count} نقطة خبرة',
  daysLabel: 'أيام',
  rewardsToastTitle: 'تم فتح مكافآت التركيز',
  rewardsToastLevelStreak: 'المستوى {level} · سلسلة {streak} {days}',
  rewardsToastTotalXp: 'إجمالي النقاط: {total}',
  rewardsToastErrorTitle: 'لم تتحدّث المكافآت',

  // Daily Habit Loop
  dailyQuestsTitle: 'حلقة العادات اليومية',
  dailyQuestsSubtitle: 'أكمل التحديات اليومية لشحن معزز السلسلة.',
  dailyQuestRewardLabel: '+{value} نقطة خبرة',
  dailyQuestComplete: 'تم الإنجاز',
  dailyQuestUndo: 'تراجع',
  dailyQuestsLoading: '...جاري تجهيز التحديات اليومية',
  dailyQuestsEmpty: 'لا توجد تحديات لليوم بعد. عد لاحقاً!',
  dailyBoosterTitle: 'معزز السلسلة',
  dailyBoosterLocked: 'أكمل جميع التحديات لفتح المكافآت الإضافية.',
  dailyBoosterReady: 'تم فتح المعزز! احصل على مكافأتك.',
  dailyChestTitle: 'صندوق مكافآت اليوم',
  dailyChestLocked: 'يفتح بعد المعزز.',
  dailyChestClaim: 'احصل على المكافآت',
  dailyChestClaimed: 'تم استلام المكافآت',
  dailyChestReadyHint: 'هدية نقاط XP',
  dailyCheckInTitle: 'تسجيل يومي بالذكاء الاصطناعي',
  dailyCheckInPrompt: 'كيف تشعر؟ وماذا تريد أن تحقق اليوم؟',
  dailyCheckInMoodLabel: 'مزاجك',
  dailyCheckInGoalLabel: 'هدف اليوم',
  dailyCheckInMoodPlaceholder: 'مثال: متحمس لكن أشعر ببعض التعب',
  dailyCheckInGoalPlaceholder: 'إنهاء مخطط التاريخ + اختبار قصير',
  dailyCheckInButton: 'أرسل لي حافزاً',
  dailyCheckInGenerating: '...يجري إعداد رسالة التحفيز',
  dailyCheckInThanks: 'أنت تستطيع ذلك!',

  // ChatBot
  chatBotTitle: 'رفيق الدراسة',
  chatBotSubtitle: 'مدعوم بواسطة الذكاء الاصطناعي',
  chatBotUpload: 'رفع PDF/نص',
  chatBotInputPlaceholder: 'اطرح سؤالاً...',
  chatBotStop: 'توقف',
  chatBotClear: 'مسح',
  chatBotContext: 'مادة الدراسة / السياق',
  chatBotReady: 'جاهز للدراسة!',
  chatBotReadySubtitle: 'الصق ملاحظاتك في القسم العلوي، أو اسألني أي شيء.',
  chatBotRateLimit: 'تجاوزت حد الطلبات. يرجى الانتظار بضع ثوانٍ.',
  chatBotFileTooLarge: 'الملف كبير جداً',
  chatBotMaterialTruncated: 'تم قص المادة',
  chatBotImageSelected: 'تم اختيار الصورة',
  chatBotPromptLimit: 'تم الوصول للحد الأقصى للنص',
  chatBotRequests: 'الطلبات',
  chatBotMaterial: 'المادة',
  chatBotPrompt: 'النص',
  chatBotThinking: 'يفكر...',
  chatBotParsingPDF: '...جاري تحليل ملف PDF',
  chatBotFileReadError: 'فشل قراءة الملف: {error}',
  chatBotInjectionWarning: 'تم اكتشاف محاولة حقن نصي. تم تعديل نطاق الاستجابة.',
  chatBotWhatIsThis: 'ما هذا؟',
  chatBotError: 'عفواً! فقدت سياق الحديث. يرجى التحقق من مفتاح API أو الاتصال بالإنترنت.',
  chatBotAborted: 'تم إيقاف البث من قبل المستخدم.',
  chatBotBadge: 'ذكاء',
  chatBotToggleMaterials: 'تبديل المواد',
  chatBotUploadImage: 'رفع صورة',
  chatBotCancelResponse: 'إلغاء الرد',

  // Grades Page
  gradesTitle: 'حاسبة الدرجات',
  addCourse: 'أضف مادة',
  noCourses: 'لا توجد مواد بعد',
  noCoursesSubtitle: 'أضف مادة للبدء في تتبع درجاتك.',
  target: 'الهدف',
  totalWeight: 'إجمالي الوزن',
  currentGrade: 'الدرجة الحالية',
  assignmentName: 'اسم الواجب',
  weight: 'وزن',
  score: 'الدرجة',
  addItem: 'أضف بند',
  recoveryPlan: 'خطة التعافي',
  aiStudyAdvisor: 'مستشار الدراسة الذكي',
  editCourse: 'تعديل المادة',
  newCourse: 'مادة جديدة',
  courseName: 'اسم المادة',
  courseNamePlaceholder: 'مثال: تفاضل وتكامل 1',
  targetGrade: 'الدرجة المستهدفة (%)',
  deleteCourseConfirm: 'هل أنت متأكد من حذف هذه المادة؟',
  gradesLoading: 'جاري تحميل مكتبك...',
  gradesLoadError: 'فشل تحميل الدرجات. يرجى المحاولة مرة أخرى.',

  // Weekly Plan Page
  weeklyPlannerTitle: 'المخطط الأسبوعي',
  weeklyPlannerSubtitle: 'خطط لأسبوعك، ونظم المهام حسب اليوم، واحفظ الجدول في جلسات الدراسة.',
  weekStarting: 'الأسبوع يبدأ',
  dashboardButton: 'لوحة التحكم',
  plannedThisWeek: 'المخطط لهذا الأسبوع',
  ofOpenTasks: 'من {total} مهام مفتوحة',
  coverage: 'التغطية',
  coverageMessageEmpty: 'أضف مهام لبدء التخطيط.',
  coverageMessageGood: 'الزخم يبدو رائعاً.',
  coverageMessageLow: 'اسحب المزيد من المهام إلى أسبوعك.',
  backlog: 'المهام المؤجلة',
  backlogSubtitle: 'احتفظ بالمهام هنا حتى تضعها في الأسبوع.',
  backlogEmpty: 'لم يتم العثور على مهام غير مجدولة.',
  filterTasks: 'تصفية المهام...',
  dueThisWeek: '{count} مستحقة هذا الأسبوع',
  aiHighlights: 'توصيات الذكاء الاصطناعي',
  aiHighlightsSubtitle: 'أهم الأولويات المقترحة',
  aiHighlightsEmpty: 'أنشئ خطة للحصول على أفكار.',
  dragDropTipsTitle: 'نصائح السحب والإفلات',
  dragDropTips: 'اضغط مع الاستمرار على المهام لثانية على الهواتف قبل السحب، أو اضغط على قائمة "إرسال إلى يوم" في بطاقات المهام المؤجلة. مرر بطاقات أيام الأسبوع جانبياً لمراجعة كل يوم.',
  askAiDraft: 'اطلب من الذكاء الاصطناعي صياغة أسبوعك',
  goalsLabel: 'الأهداف (واحد في كل سطر)',
  goalsPlaceholder: 'إنهاء تقرير المختبر\nمراجعة فصول التفاضل والتكامل\nالتدرب على العرض التقديمي',
  commitmentsLabel: 'الالتزامات (فصول دراسية، عمل، إلخ)',
  commitmentsPlaceholder: 'مختبر يوم الثلاثاء 2 مساءً\nعشاء عائلي يوم الخميس',
  risksLabel: 'المخاطر / المعوقات',
  risksPlaceholder: 'تأخيرات محتملة في مشروع المجموعة، أمسيات محدودة بسبب تدريب الرياضة',
  generatePlanButton: 'إنشاء خطة أسبوعية (ذكاء اصطناعي)',
  clearBoardButton: 'مسح اللوحة',
  savePlanButton: 'حفظ الخطة الأسبوعية',
  statusGenerated: 'تم إنشاء الخطة الأسبوعية. راجع وعدل قبل الحفظ.',
  statusSaved: 'تم حفظ الخطة الأسبوعية في جدولك.',
  statusCleared: 'تم مسح اللوحة. ابدأ ترتيب المهام مرة أخرى.',
  statusNothingToSave: 'لا يوجد شيء للحفظ بعد. اسحب المهام إلى الأسبوع قبل الحفظ.',
  errorGenerate: 'تعذر إنشاء الخطة. حاول مرة أخرى بعد لحظات.',
  errorSave: 'تعذر حفظ الخطة. يرجى المحاولة مرة أخرى.',
  aiGenerationError: 'فشل إنشاء خطة الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.',
  loadingTasks: 'جاري تحميل مهامك...',
  loadError: 'تعذر تحميل المهام. يرجى التحديث أو المحاولة مرة أخرى لاحقاً.',
  backToDashboard: 'العودة إلى لوحة التحكم',
  dropTasksHere: 'أفلت المهام هنا',
  dragTasksHere: 'اسحب المهام هنا لإبقائها غير مخططة حالياً.',
  hideList: 'إخفاء القائمة',
  showList: 'إظهار القائمة',
  sendToDay: 'إرسال إلى يوم',
  chooseDay: 'اختر يوماً...',
  overview: 'نظرة عامة',
  metrics: 'المقاييس',
  focusMinutes: 'دقائق التركيز',
  restBlocks: 'فترات الراحة',
  stretchGoals: 'أهداف إضافية',
  untitledTask: 'مهمة بدون عنوان',
  signInToGenerate: 'سجّل الدخول لإنشاء خطة بالذكاء الاصطناعي.',
  signInToSave: 'سجّل الدخول لحفظ خطتك الأسبوعية.',
  weeklyPlanNote: 'الخطة الأسبوعية: {overview}',
  weeklyPlanSlot: 'خانة الخطة الأسبوعية',
  tasks: 'مهام',

  studyGroupsPhaseLabel: 'المرحلة 8 · مختبرات اجتماعية',
  studyGroupsHeroTitle: 'مقر مجموعات الدراسة',
  studyGroupsHeroSubtitle: 'نسّق سباقات التركيز، واحتفل بالإنجازات، وابقَ دائماً على قدر المساءلة مع فريقك.',
  studyGroupsInviteCodeLabel: 'رمز الدعوة',
  studyGroupsStatusCreated: 'تم إنشاء المجموعة! ادعُ أصدقاءك باستخدام الرمز على اليمين.',
  studyGroupsStatusJoin: 'تم إرسال الطلب! عد لاحقاً لمعرفة حالة عضويتك.',
  studyGroupsStatusLeft: 'غادرتَ المجموعة',
  studyGroupsStatusPrivacySaved: 'تم حفظ إعدادات الخصوصية',
  studyGroupsStatusChallengeCreated: 'تمت إضافة التحدي إلى المجموعة',
  studyGroupsErrorLoad: 'تعذّر تحميل المجموعات حالياً',
  studyGroupsErrorCreate: 'تعذّر إنشاء المجموعة',
  studyGroupsErrorJoin: 'تعذّر الانضمام إلى المجموعة',
  studyGroupsErrorLeave: 'تعذّر مغادرة المجموعة',
  studyGroupsErrorPrivacy: 'فشل تحديث الخصوصية',
  studyGroupsErrorChallenge: 'تعذّر إنشاء التحدي',
  studyGroupsErrorDetails: 'فشل تحميل تفاصيل المجموعة',
  studyGroupsRosterLoading: '...جاري تحميل الأعضاء',
  studyGroupsRosterEmpty: 'لا يوجد أعضاء بعد.',
  studyGroupsYourGroupsTitle: 'مجموعاتك',
  studyGroupsYourGroupsLoading: '...جاري تحميل مساحاتك',
  studyGroupsYourGroupsEmpty: 'لم تنضم إلى أي مجموعة بعد. أنشئ واحدة أو استخدم رمز دعوة أدناه.',
  studyGroupsLaunchTitle: 'أنشئ مجموعة جديدة',
  studyGroupsNameLabel: 'اسم المجموعة',
  studyGroupsNamePlaceholder: 'نادي محاربي الليل',
  studyGroupsDescriptionLabel: 'الوصف',
  studyGroupsDescriptionPlaceholder: 'لقاءات مساءلة أسبوعية وسباقات تركيز متزامنة.',
  studyGroupsPrivacyLabel: 'الخصوصية',
  studyGroupsPrivacyPublicLabel: 'عامة',
  studyGroupsPrivacyPublicHint: 'يمكن لأي شخص العثور على مجموعتك والانضمام إليها',
  studyGroupsPrivacyInviteLabel: 'بالدعوة فقط',
  studyGroupsPrivacyInviteHint: 'يتطلب رمز الدعوة للانضمام',
  studyGroupsPrivacyPrivateLabel: 'خاصة',
  studyGroupsPrivacyPrivateHint: 'يجب على المالك الموافقة على الأعضاء الجدد',
  studyGroupsAllowInvitesLabel: 'السماح للأعضاء بمشاركة رمز الدعوة',
  studyGroupsCreateButton: 'إنشاء مجموعة',
  studyGroupsJoinTitle: 'انضم بواسطة رمز',
  studyGroupsJoinCodeLabel: 'رمز الدعوة',
  studyGroupsJoinCodePlaceholder: 'ABCD1234',
  studyGroupsJoinButton: 'طلب الوصول',
  studyGroupsActiveDescriptionFallback: 'لا يوجد وصف بعد.',
  studyGroupsRoleLabel: 'الدور: {role}',
  studyGroupsStatusLabel: 'الحالة: {status}',
  studyGroupsPrivacyControlsTitle: 'ضوابط الخصوصية',
  studyGroupsPrivacyMembersHint: 'يمكن للأعضاء مشاركة رمز الدعوة',
  studyGroupsPrivacySaveButton: 'حفظ الضوابط',
  studyGroupsMembersTitle: 'قائمة الأعضاء',
  studyGroupsMembersLeaveButton: 'غادر المجموعة',
  studyGroupsMemberFocus: '{minutes} دقيقة تركيز',
  studyGroupsMemberXp: '{xp} نقطة XP',
  studyGroupsChallengesTitle: 'تحديات المجموعة',
  studyGroupsChallengesSubtitle: 'أبقِ الجميع على هدف مشترك.',
  studyGroupsChallengesEmpty: 'لا توجد تحديات بعد. أطلق الأول الآن!',
  studyGroupsChallengesCreateTitle: 'إنشاء تحدٍ',
  studyGroupsChallengeTitleLabel: 'العنوان',
  studyGroupsChallengeXpLabel: 'مكافأة XP',
  studyGroupsChallengeStartLabel: 'تاريخ البدء',
  studyGroupsChallengeEndLabel: 'تاريخ الانتهاء',
  studyGroupsChallengeDescriptionLabel: 'الوصف',
  studyGroupsChallengeTargetLabel: 'هدف التركيز (دقائق)',
  studyGroupsChallengeButton: 'نشر التحدي',
  studyGroupsChallengeDefaultTitle: 'سباق التركيز العميق',
  studyGroupsChallengeDefaultDescription: 'حققوا هدف التركيز الجماعي لهذا الأسبوع.',
  studyGroupsEmptyStateTitle: 'أنشئ أو انضم إلى مجموعة للبدء.',
  studyGroupsEmptyStateSubtitle: 'ستظهر قوائم الأعضاء والإعدادات والتحديات هنا بعد امتلاك مجموعة نشطة.',

  // Group Goals
  groupGoalsTitle: 'أهداف المجموعة',
  groupGoalsEmpty: 'لا توجد أهداف بعد. أنشئ واحداً لتحفيز الفريق!',
  groupGoalsCreate: 'هدف جديد',
  groupGoalsProgress: 'التقدم',
  groupGoalsContribute: 'ساهم',
  groupGoalsContributed: 'ساهمت بـ {amount} {unit}',
  groupGoalsTargetLabel: 'الهدف',
  groupGoalsUnitTasks: 'مهمة',
  groupGoalsUnitMinutes: 'دقيقة',
  groupGoalsUnitSessions: 'جلسة',
  groupGoalsCompleted: 'مكتمل!',
  groupGoalsTitleLabel: 'عنوان الهدف',
  groupGoalsDescriptionLabel: 'الوصف (اختياري)',
  groupGoalsTargetDateLabel: 'الموعد النهائي',
  groupGoalsTargetValueLabel: 'القيمة المستهدفة',
  groupGoalsUnitLabel: 'الوحدة',
  groupActivityTitle: 'نشاط المجموعة',
  groupActivityEmpty: 'لا يوجد نشاط بعد. ابدأ بإنشاء هدف!',
  groupActivityGoalCreated: 'أنشأ {user} هدفاً: {goal}',
  groupActivityGoalProgress: 'ساهم {user} بـ {amount} في {goal}',
  groupActivityGoalCompleted: '🎉 اكتمل الهدف: {goal}!',
  groupActivityMemberJoined: 'انضم {user} إلى المجموعة',
  groupActivityFocusSession: 'أكمل {user} جلسة تركيز',
  groupActivityTaskCompleted: 'أكمل {user} مهمة',

  accountabilityPhaseLabel: 'رفاق الدراسة',
  accountabilityHeroTitle: 'رفاق الدراسة',
  accountabilityHeroSubtitle: 'تعاون مع رفيق دراسي للمتابعة اليومية وتتبع السلسلة. 🎯',
  accountabilityShareCodeLabel: 'رمز الرفيق الخاص بك',
  accountabilityShareCodeButton: 'نسخ',
  accountabilityStatusInviteSent: 'تم إرسال الدعوة! شارك الرمز مع رفيق دراستك.',
  accountabilityStatusCheckIn: 'تم تسجيل المتابعة! 🎉 واصل الحفاظ على السلسلة!',
  accountabilityStatusCopied: 'تم النسخ! أرسل هذا الرمز إلى رفيقك.',
  accountabilityStatusAlreadyChecked: 'تم تسجيل متابعة اليوم بالفعل. عد غداً.',
  accountabilityErrorLoad: 'تعذّر تحميل روابط الشركاء',
  accountabilityErrorInvite: 'تعذّر إرسال الدعوة',
  accountabilityErrorUpdate: 'تعذّر تحديث الدعوة',
  accountabilityErrorCheckIn: 'تعذّر تسجيل المتابعة',
  accountabilityErrorClipboard: 'تم حظر الحافظة—انسخ المعرّف يدوياً.',
  accountabilityInviteTitle: 'أضف رفيق دراسي',
  accountabilityInviteDescription: 'شارك رمز الرفيق الخاص بك أو الصق رمز صديق للتواصل.',
  accountabilityPartnerIdLabel: 'رمز الرفيق',
  accountabilityPartnerIdPlaceholder: 'الصق رمز الرفيق هنا',
  accountabilitySendInviteButton: 'إرسال الدعوة',
  accountabilityHowItWorksTitle: 'كيف يعمل؟',
  accountabilityHowItWorksStep1: 'تبادل رموز الرفاق مع صديق تثق به.',
  accountabilityHowItWorksStep2: 'أرسل دعوة وانتظر الموافقة.',
  accountabilityHowItWorksStep3: 'المتابعات اليومية تزيد سلسلتك المشتركة! 🔥',
  accountabilityPendingTitle: 'الطلبات المعلقة',
  accountabilityPendingSubtitle: 'وافق على الطلبات أو ألغِها.',
  accountabilityPendingLoading: '...جاري تحميل الطلبات',
  accountabilityPendingEmpty: 'لا توجد طلبات معلقة حالياً.',
  accountabilityIncomingLabel: 'طلب وارد من {partner}',
  accountabilityIncomingHint: 'بانتظار ردك',
  accountabilityDeclineButton: 'رفض',
  accountabilityAcceptButton: 'قبول',
  accountabilityWaitingLabel: 'بانتظار {partner}',
  accountabilityWaitingHint: 'أُرسل في {date}',
  accountabilityCancelButton: 'إلغاء',
  accountabilityActiveTitle: 'رفاقك',
  accountabilityActiveSubtitle: 'المتابعات السريعة تحافظ على سلسلتك! 🔥',
  accountabilityActiveEmpty: 'سيظهر رفاقك هنا بعد قبولهم لدعوتك.',
  accountabilityPartnerLabel: 'الرفيق {id}',
  accountabilityLastCheckIn: 'آخر متابعة: {date}',
  accountabilityStreakBadge: 'سلسلة {count} يوم',
  accountabilityPrivacyLabel: 'الخصوصية: {value}',
  accountabilityCheckInButton: 'سجل المتابعة',
  accountabilityCheckInLocked: 'عد غداً',
  accountabilityCheckInLoading: 'جاري التسجيل',
  accountabilityEndLinkButton: 'إنهاء الرابط',
  accountabilityTabMyBuddies: 'رفاقي',
  accountabilityTabAddBuddy: 'أضف رفيق',
  accountabilityTabPending: 'معلقة',
  accountabilityWeekProgress: 'تقدم هذا الأسبوع',
  accountabilityEmptyTitle: 'لا يوجد رفاق دراسة بعد',
  accountabilityEmptySubtitle: 'تعاون مع صديق لمضاعفة تحفيزك! شارك رمز الرفيق أعلاه للبدء. 🚀',

  // Settings Modal
  settingsTitle: 'الإعدادات',
  settingsSubtitle: 'إدارة تفضيلات الدراسة',
  settingsLanguage: 'اللغة',
  settingsStudyPreferences: 'تفضيلات الدراسة',
  settingsRetentionHours: 'مدة الاحتفاظ بالمهام المكتملة (ساعات)',
  settingsWorkInterval: 'فترة العمل (دقائق)',
  settingsBreakInterval: 'فترة الاستراحة (دقائق)',
  settingsSaveButton: 'حفظ التفضيلات',
  settingsSaved: 'تم الحفظ ✓',
  profileSectionTitle: 'الملف الشخصي',
  profileFullNameLabel: 'الاسم الكامل',
  profilePersonaLabel: 'اللقب المفضل',
  profileTimezoneLabel: 'المنطقة الزمنية',
  profileBioLabel: 'نبذة / مجال الدراسة (اختياري)',
  profileSaveButton: 'حفظ الملف الشخصي',
  profileSaved: 'تم تحديث الملف ✓',
  profileMissingName: 'أدخل اسمك ليظهر للآخرين.',
  profileSetupTitle: 'أكمل ملفك الشخصي',
  profileSetupSubtitle: 'نستخدم اسمك في لوحات المتصدرين ومجموعات الدراسة.',

  // Landing Page
  landingNavFeatures: 'الميزات',
  landingNavHowItWorks: 'كيف يعمل',
  landingNavPricing: 'الأسعار',
  landingNavFAQ: 'الأسئلة الشائعة',
  landingNavRoadmap: 'خارطة الطريق',
  landingNavGetStarted: 'ابدأ الآن',

  landingHeroBadge: 'مدعوم بالذكاء الاصطناعي ✨',
  landingHeroTitle1: 'قدراتك الأكاديمية',
  landingHeroTitle2: 'أطلقها الذكاء الاصطناعي',
  landingHeroSubtitle: "تريو ليس مجرد مخطط. إنه نظام تشغيل دراسي ذكي يحول مهامك إلى مهمات، ويتنبأ بوقت دراستك، ويدربك لتحقيق درجات أفضل.",
  landingHeroCTA: 'ابدأ مهمتك',
  landingHeroSecondaryCTA: 'شاهد سحر الذكاء الاصطناعي',

  landingSocialPartner1: 'عارض في قمة الويب',
  landingSocialPartner2: 'صنعه طلاب',
  landingSocialPartner3: 'مشغل بواسطة Supabase',
  landingSocialPartner4: 'نماذج ذكاء اصطناعي متقدمة',

  landingProblemTitle: 'الطريقة القديمة',
  landingProblemItem1: 'غارق في الواجبات المتناثرة',
  landingProblemItem2: 'تخمين المدة التي ستستغرقها المهام',
  landingProblemItem3: 'الحشو قبل الامتحانات بلا خطة',
  landingProblemItem4: 'الدراسة وحيداً بلا حافز',

  landingSolutionTitle: 'طريقة تريو',
  landingSolutionItem1: 'الذكاء الاصطناعي يقسم المهام الكبيرة تلقائياً',
  landingSolutionItem2: 'تقديرات ذكية لمدة الدراسة',
  landingSolutionItem3: 'خطط تعافٍ استراتيجية للدرجات المنخفضة',
  landingSolutionItem4: 'تقدم قائم على اللعب مع نقاط XP ومكافآت',

  landingAITitlePrefix: 'معلمك الشخصي',
  landingAITitleSuffix: 'بالذكاء الاصطناعي',
  landingAISubtitle: "تريو لا يدرج مهامك فحسب. إنه يفهمها. جرب قوة الذكاء الاصطناعي الذي يساعدك بفعالية على الدراسة بشكل أفضل.",
  landingAIFeature1Title: 'تقسيم المهام الذكي',
  landingAIFeature1Desc: "هل تشعر بالإرهاق من 'كتابة مقال'؟ يقسمه ذكاء تريو إلى خطوات قابلة للتنفيذ مثل 'البحث'، 'المخطط'، و'المسودة' فوراً.",
  landingAIFeature2Title: 'تقدير الوقت بالذكاء الاصطناعي',
  landingAIFeature2Desc: 'توقف عن التخمين. يتنبأ تريو بدقة بالمدة التي ستستغرقها المهام بناءً على الصعوبة والمادة، لتخطط بواقعية.',
  landingAIFeature3Title: 'خطط تعافي الدرجات',
  landingAIFeature3Desc: 'تأخرت؟ يحلل الذكاء الاصطناعي درجاتك الحالية والواجبات المتبقية لبناء مسار رياضي نحو هدفك.',
  landingAIFeature4Title: 'توجيه يعتمد على المزاج',
  landingAIFeature4Desc: 'تشعر بالتوتر؟ تريو يكيف نصائحه. أخبره بما تشعر به، واحصل على تحفيز شخصي لمواصلة العمل.',
  landingAIFeature5Title: 'نصائح واعية بالسياق',
  landingAIFeature5Desc: "عالِق في مادة معينة؟ احصل على استراتيجيات دراسة فورية وذات صلة بالمهمة التي تعمل عليها بالضبط.",

  landingFeaturesTitle: 'كل ما تحتاجه للتفوق',
  landingFeaturesSubtitle: 'ميزات قوية مصممة خصيصاً لسير عمل الطالب الحديث.',
  landingFeaturesItem1Title: 'مركز القيادة',
  landingFeaturesItem1Desc: 'حياتك الأكاديمية بأكملها بلمحة واحدة. المهام والمواعيد النهائية والتقدم في عرض موحد.',
  landingFeaturesItem2Title: 'اللعب (Gamification)',
  landingFeaturesItem2Desc: 'اكسب نقاط XP للدراسة، وارفع مستوى شخصيتك، وحافظ على السلاسل. اجعل النجاح إدماناً.',
  landingFeaturesItem3Title: 'تتبع الإحصائيات',
  landingFeaturesItem3Desc: "تخيل 'إحصائيات شخصيتك' (الدرجات ووقت التركيز) لتحديد نقاط قوتك وضعفك.",
  landingFeaturesItem4Title: 'وضع تعدد اللاعبين',
  landingFeaturesItem4Desc: 'شكّل فرقاً (مجموعات دراسة)، وشارك الغنائم (الموارد)، وتسلق لوحات المتصدرين العالمية.',
  landingFeaturesItem5Title: 'قاعدة المعرفة',
  landingFeaturesItem5Desc: 'نظم الملاحظات وملفات PDF والروابط لكل مهمة (مادة) في مخزون واحد يسهل الوصول إليه.',
  landingFeaturesItem6Title: 'قدرة التركيز',
  landingFeaturesItem6Desc: "فعّل 'وضع التركيز' لحجب المشتتات وزيادة مضاعف إنتاجيتك.",

  landingHowItWorksTitle: "كيف يعمل؟",
  landingHowItWorksStep1Title: "أدخل موادك",
  landingHowItWorksStep1Desc: "أضف مهامك، امتحاناتك، والمنهج الدراسي ببساطة.",
  landingHowItWorksStep2Title: "استراتيجية الذكاء الاصطناعي",
  landingHowItWorksStep2Desc: "يقوم تريو ببناء جدول مخصص وتقسيم للمهام.",
  landingHowItWorksStep3Title: "نفذ وانتصر",
  landingHowItWorksStep3Desc: "اتبع الخطة، اكسب XP، وتفوق في امتحاناتك.",

  landingRoadmapTitle: 'خارطة الطريق',
  landingRoadmapSubtitle: "انظر ما هو قادم لتريو.",
  landingRoadmapQ1Title: 'الجدولة الذكية',
  landingRoadmapQ1Item1: 'تكامل التقويم',
  landingRoadmapQ1Item2: 'حل تعارض المواعيد بالذكاء الاصطناعي',
  landingRoadmapQ1Item3: 'نسخة تجريبية لتطبيق الهاتف',
  landingRoadmapQ2Title: 'التعاون',
  landingRoadmapQ2Item1: 'غرف دراسة جماعية',
  landingRoadmapQ2Item2: 'مكتبات موارد مشتركة',
  landingRoadmapQ2Item3: 'سوق دروس خصوصية بين الأقران',
  landingRoadmapQ3Title: 'ذكاء اصطناعي متقدم',
  landingRoadmapQ3Item1: 'مساعد تصحيح المقالات',
  landingRoadmapQ3Item2: 'تحويل الصوت إلى ملخصات',
  landingRoadmapQ3Item3: 'مسارات تعلم مخصصة',

  landingPricingTitle: 'أسعار بسيطة',
  landingPricingFreeTitle: 'البداية المجانية',
  landingPricingFreePrice: '$0',
  landingPricingFreeItem1: 'إدارة مهام أساسية',
  landingPricingFreeItem2: '3 جلسات تركيز / يومياً',
  landingPricingFreeItem3: 'تاريخ أسبوع واحد',
  landingPricingFreeCTA: 'ابدأ مجاناً',
  landingPricingPlusTitle: 'تريو بلس',
  landingPricingPlusPrice: '$5',
  landingPricingPlusItem1: 'خطط دراسية بالذكاء الاصطناعي غير محدودة',
  landingPricingPlusItem2: 'جلسات تركيز غير محدودة',
  landingPricingPlusItem3: 'تحليلات متقدمة',
  landingPricingPlusItem4: 'مزامنة سحابية ونشخ احتياطي',
  landingPricingJoinWaitlist: 'انضم للقائمة',
  landingPricingJoinSuccess: 'أنت في القائمة! 🚀',
  landingPricingComingSoon: 'قريباً',
  landingPricingEmailPlaceholder: 'أدخل بريدك الإلكتروني',

  landingFAQTitle: 'أسئلة شائعة',
  landingFAQ1Q: 'هل تريو مجاني حقاً؟',
  landingFAQ1A: 'نعم! ميزاتنا الأساسية مجانية تماماً للطلاب. نخطط لتقديم ميزات مدفوعة للمحترفين لاحقاً.',
  landingFAQ2Q: 'هل يمكنني استخدامه على هاتفي؟',
  landingFAQ2A: 'تريو تطبيق ويب متجاوب تماماً يعمل بشكل رائع على متصفحات الهاتف. تطبيق الهاتف الأصلي ضمن خطتنا لعام 2026.',
  landingFAQ3Q: 'كيف يعمل التخطيط بالذكاء الاصطناعي؟',
  landingFAQ3A: 'نستخدم نماذج ذكاء اصطناعي متقدمة لتحليل مهامك ومواعيدك، ثم نقترح جدولاً مثالياً بناءً على عاداتك الدراسية.',
  landingFAQ4Q: 'هل بياناتي آمنة؟',
  landingFAQ4A: 'بالتأكيد. نستخدم Supabase لأمان من الدرجة المؤسسية ولا نشارك بياناتك الشخصية مع أطراف ثالثة.',

  landingFooterTagline: 'نظام التشغيل المدعوم بالذكاء الاصطناعي لنجاحك الأكاديمي. صنعه طلاب، للطلاب.',
  landingFooterProduct: 'المنتج',
  landingFooterLegal: 'قانوني',
  landingFooterPrivacy: 'سياسة الخصوصية',
  landingFooterTerms: 'شروط الخدمة',
  landingFooterContact: 'تواصل معنا',
  landingFooterRights: 'جميع الحقوق محفوظة.',

  // Landing Page - New Features - Arabic
  landingWeeklyTitle: "المخطط الأسبوعي الذكي",
  landingWeeklyDesc: "توقف عن القلق بشأن جدولك. اسحب وافلت المهام ودع الذكاء الاصطناعي ينظم وقتك تلقائياً. يتضمن قائمة انتظار للمهام غير المجدولة.",
  landingWeeklyFeature1: "جدولة تلقائية بالذكاء الاصطناعي",
  landingWeeklyFeature2: "واجهة السحب والإفلات",
  landingWeeklyFeature3: "قائمة مهام ذكية",

  landingHeroBullet1: "خطط أسبوعك تلقائياً",
  landingHeroBullet2: "توقع وقت الدراسة",
  landingHeroBullet3: "حوّل المهام إلى جلسات تركيز",
  landingCTAStartFree: "ابدأ مجاناً",
  landingCTAWatchDemo: "شاهد العرض",

  landingProofStudents: "صنعه طلاب",
  landingProofSummit: "عارض في قمة الويب",
  landingProofPrivacy: "الخصوصية أولاً",
  landingProofAI: "تخطيط بمساعدة الذكاء الاصطناعي",
  landingProofSupabase: "مدعوم بواسطة Supabase",

  landingComparisonTitle: "ادرس بذكاء لا بجهد",
  landingComparisonOldWay: "الطريقة التقليدية",
  landingComparisonNewWay: "طريقة تريو",

  landingFinalCTATitle: "ابدأ التخطيط بذكاء اليوم",
  landingFinalCTASubtitle: "ابدأ مجاناً. لا حاجة لبطاقة ائتمان.",

  landingGamificationTitle: "ارتقِ بتجربة تعلمك",
  landingGamificationDesc: "حول الدراسة إلى لعبة. أكمل المهام اليومية، اكسب نقاط الخبرة، وقم بتربية حيوانك الأليف الذكي. حافظ على الحماس مع لوحات المتصدرين.",
  landingGamificationFeature1: "حيوانات أليفة ذكية",
  landingGamificationFeature2: "مهام يومية ونقاط خبرة",
  landingGamificationFeature3: "لوحات متصدرين عالمية",

  landingGradesTitle: "منقذ الدرجات وحاسبة المعدل",
  landingGradesDesc: "اعرف مستواك بدقة. احسب معدل GPA واحصل على 'خطط إنقاذ' مولدة بالذكاء الاصطناعي لرفع درجاتك قبل الامتحانات النهائية.",
  landingGradesFeature1: "حاسبة المعدل التراكمي",
  landingGradesFeature2: "خطط إنقاذ بالذكاء الاصطناعي",
  landingGradesFeature3: "سيناريوهات 'ماذا لو'",

  landingGroupsTitle: "مجموعات دراسية تعاونية",
  landingGroupsDesc: "لا تدرس وحدك. انضم لمجموعات خاصة بالمواد، شارك المصادر، وحافظ على الالتزام مع أدوات الدردشة والمشاركة المدمجة.",
  landingGroupsFeature1: "دردشة فورية",
  landingGroupsFeature2: "مشاركة المصادر",
  landingGroupsFeature3: "أدوات الالتزام والمساءلة",

  landingStudentsTitle: 'للطلاب',
  landingStudentsDesc: 'أتقن موادك الدراسية واستعد وقت فراغك.',
  landingStudentsItem1: 'لا تفوت موعداً نهائياً أبداً',
  landingStudentsItem2: 'ارفع معدلك التراكمي',
  landingStudentsItem3: 'قلل قلق الاختبارات',
  landingStudentsCTA: 'اعرف المزيد',

  landingUniTitle: 'للجامعات',
  landingUniDesc: 'مكّن طلابك بأدوات حديثة للنجاح.',
  landingUniItem1: 'حسّن معدلات الاستبقاء',
  landingUniItem2: 'تحليلات حول أداء الطلاب',
  landingUniItem3: 'تكامل الحرم الجامعي الرقمي',
  landingUniCTA: 'شارك معنا',

  // Feature Reveal Section
  landingRevealSectionTitle: "أطلق العنان",
  landingRevealSectionHighlight: "لإمكانياتك الكاملة",
  landingRevealDailyTitle: "التركيز اليومي",
  landingRevealDailyDesc: "ابق على المسار الصحيح مع المهام اليومية.",
  landingRevealWeeklyTitle: "الخطة الأسبوعية",
  landingRevealWeeklyDesc: "تخيل أسبوعك القادم.",
  landingRevealGradesTitle: "تتبع الدرجات",
  landingRevealGradesDesc: "راقب أدائك الأكاديمي.",
  landingRevealAITitle: "مساعدة الذكاء الاصطناعي",
  landingRevealAIDesc: "احصل على المساعدة عندما تحتاجها.",
  landingAIChatQuestion: "كيف أحل هذا؟",
  landingAIChatAnswer: "إليك خطوات الحل...",
  landingRevealPhysicsTitle: "إتقان المواد",
  landingRevealPhysicsDesc: "تعمق في موادك.",
  landingRevealConnectTitle: "تواصل وتعلم",
  landingRevealConnectDesc: "انضم إلى مجموعات الدراسة وتعلم معًا.",

  // Beta Banner
  betaBannerPrefix: 'بيتا:',
  betaBannerText: 'قيد التطوير النشط.',
  betaBannerFeedback: 'ملاحظات:',

  // Grade Tracking Section (Restored)
  landingGradeTrackBadge: "تتبع الدرجات",
  landingGradeTrackTitle: "اعرف مستواك بدقة.",
  landingGradeTrackSubtitle: "تخيل أداءك الأكاديمي في الوقت الفعلي. حدد الدرجات المستهدفة، وتتبع المهام، واعرف بالضبط ما تحتاج إلى تحقيقه للتفوق في الفصل.",
  landingGradeTrackFeature1: "حساب المعدل الموزون",
  landingGradeTrackFeature2: "خطط التعافي للدرجات المنخفضة",
  landingGradeTrackCard1Class: "التفاضل والتكامل المتقدم ٢",
  landingGradeTrackCard1Meta: "MATH 202 • ٤ ساعات",
  landingGradeTrackCard1Grade: "أ",
  landingGradeTrackCard2Class: "الفيزياء ١٠١",
  landingGradeTrackCard2Meta: "PHYS 101 • ٣ ساعات",
  landingGradeTrackCard2Grade: "ب+",
  landingGradeTrackCard2MetaRising: "صاعد",
  landingGradeTrackCard3Class: "مقدمة في علوم الحاسب",
  landingGradeTrackCard3Meta: "CS 101 • ٤ ساعات",
  landingGradeTrackCard3Grade: "أ-",
  landingGradeProgress: "التقدم نحو الهدف",
  landingGradeTrackFloatBadge: "المعدل",

  // Auth Page New
  authPageTitleSignUp: 'انشاء حساب',
  authPageTitleSignIn: 'مرحبًا بعودتك',
  authPageSubtitleSignUp: 'ابدأ رحلتك للحصول على درجات أفضل اليوم.',
  authPageSubtitleSignIn: 'الرجاء إدخال التفاصيل الخاصة بك لتسجيل الدخول.',
  authPageGoogleContinue: 'المتابعة باستخدام Google',
  authPageOrEmail: 'أو باستخدام البريد الإلكتروني',
  authPageEmailLabel: 'عنوان البريد الإلكتروني',
  authPagePasswordLabel: 'كلمة المرور',
  authPageForgotPassword: 'هل نسيت كلمة المرور؟',
  authPageButtonSignUp: 'انشاء حساب',
  authPageButtonSignIn: 'تسجيل الدخول',
  authPageButtonLoadingSignUp: 'جاري انشاء الحساب...',
  authPageButtonLoadingSignIn: 'جاري تسجيل الدخول...',
  authPageSwitchAccountQuestionSignUp: 'هل لديك حساب بالفعل؟',
  authPageSwitchAccountQuestionSignIn: 'ليس لديك حساب؟',
  authPageSwitchActionSignUp: 'سجل الدخول بدلاً من ذلك',
  authPageSwitchActionSignIn: 'انشاء حساب مجاني',
  authPageTOSPrefix: 'بالمتابعة ، فإنك توافق على',
  authPageTOSLink: 'شروط الخدمة',
  authPagePrivacyLink: 'سياسة الخصوصية',
  authPageSideTitle1: 'أتقن دراستك مع',
  authPageSideTitle2: 'التركيز المدعوم بالذكاء الاصطناعي',
  authPageSideSubtitle: 'انضم إلى الطلاب الذين ينظمون حياتهم الأكاديمية ، ويعززون معدلهم التراكمي ، ويقللون من التوتر مع Triyo.',
  authPageSideFeature1: 'مجاني للطلاب',
  authPageSideFeature2: 'لا يلزم وجود بطاقة ائتمان',
  authPageSuccessSignUp: '✅ تم إنشاء الحساب! يمكنك الآن تسجيل الدخول.',
  authPageSuccessSignUpConfirm: '✅ تم إنشاء الحساب! يرجى التحقق من بريدك الإلكتروني لتأكيد حسابك قبل تسجيل الدخول.',
  and: 'و',

  // Forgot Password Page
  forgotPassTitle: 'إعادة تعيين كلمة المرور',
  forgotPassSubtitle: 'أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.',
  forgotPassLabelEmail: 'عنوان البريد الإلكتروني',
  forgotPassButtonSend: 'أرسل رابط إعادة التعيين',
  forgotPassButtonSending: 'جاري الإرسال...',
  forgotPassBackToLogin: 'العودة لتسجيل الدخول',
  forgotPassSideTitle1: 'لا تقلق،',
  forgotPassSideTitle2: 'نحن هنا لمساعدتك.',
  forgotPassSuccess: 'تحقق من بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور.',
  forgotPassErrorRateLimit: 'طلبات كثيرة جداً. يرجى المحاولة مرة أخرى بعد دقيقة.',
  forgotPassErrorGeneric: 'فشل إرسال بريد إعادة التعيين.',

  // Reset Password Page
  resetPassTitle: 'تعيين كلمة مرور جديدة',
  resetPassSubtitle: 'الرجاء إدخال كلمة المرور الجديدة أدناه.',
  resetPassLabelPass: 'كلمة المرور الجديدة',
  resetPassLabelConfirm: 'تأكيد كلمة المرور',
  resetPassButtonUpdate: 'تحديث كلمة المرور',
  resetPassButtonUpdating: 'جاري التحديث...',
  resetPassSuccess: 'تم تحديث كلمة المرور بنجاح! جاري إعادة التوجيه...',
  resetPassErrorMismatch: 'كلمات المرور غير متطابقة.',
  resetPassErrorLength: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل.',
  resetPassErrorInvalidLink: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى المحاولة مرة أخرى.',
  resetPassErrorGeneric: 'فشل تحديث كلمة المرور.',
  resetPassRequestNewLink: 'طلب رابط جديد',

  // New Task Modal (Arabic)
  ntmSubtitle: 'أضف عنصر دراسة إلى لوحتك',
  ntmCatTask: 'مهمة',
  ntmCatExam: 'امتحان',
  ntmCatProject: 'مشروع',
  ntmCatOther: 'أخرى',
  ntmTitleLabel: 'العنوان',
  ntmErrTitleRequired: 'العنوان مطلوب',
  ntmErrTitleMax: 'الحد الأقصى {max} حرف',
  ntmErrFutureTime: 'اختر وقتاً في المستقبل',
  ntmEstTime: 'الوقت المقدر (دقيقة)',
  ntmDifficulty: 'الصعوبة',
  ntmType: 'النوع',
  ntmTypeTagsPlaceholder: 'أضف وسوم مخصصة (مفصولة بفواصل)',
  ntmRecurringLabel: 'مهمة متكررة',
  ntmAISuggest: 'اقتراح ذكي',
  ntmAIEstimate: 'تقدير الوقت',
  ntmThinking: 'جاري التفكير...',
  ntmCancel: 'إلغاء',

  // ChatBot (Arabic)
  cbPersonaBuddy: 'رفيق الدراسة',
  cbPersonaProfessor: 'البروفيسور',
  cbPersonaSocratic: 'سقراطي',
  cbPersonaELI5: 'ببساطة (ELI5)',
  cbQuickSummarize: 'لخص هذا',
  cbQuickQuiz: 'اختبرني',
  cbQuickPlan: 'أنشئ خطة دراسية',
  cbQuickExplain: 'اشرح المفاهيم الأساسية',
  cbSelectPersona: 'اختر الشخصية',
  cbPoweredBy: 'مدعوم بالذكاء الاصطناعي',
  cbContext: 'سياق الدراسة',
  cbClear: 'مسح',
  cbUpload: 'رفع ملف',
  cbPastePlaceholder: 'الصق الملاحظات، مسودات المقالات، أو تفاصيل الواجب هنا...',
  cbHello: "مرحباً! أنا {persona} الخاص بك",
  cbIntroBuddy: "أنا هنا لمساعدتك في التفوق في دراستك! ما الذي نعمل عليه؟",
  cbIntroSocratic: "أنا هنا لإرشادك إلى الإجابات، وليس مجرد إعطائها لك.",
  cbImageAttached: 'تم إرفاق صورة',
  cbAskPlaceholder: 'اسأل أي شيء...',

  // Legal Modal (Arabic)
  legalModalIUnderstand: 'أفهم ذلك',
  legalModalPrint: 'طباعة',
  legalModalLastUpdated: 'آخر تحديث',
  legalModalQuickNav: 'التنقل السريع',
  legalModalSections: 'أقسام',
  legalModalPrivacyTitle: 'سياسة الخصوصية',
  legalModalTermsTitle: 'شروط الخدمة',

  // Quota Indicator (Arabic)
  quotaUnlimited: 'غير محدود',
  quotaRemaining: 'المتبقي اليوم',
  quotaAiTips: 'نصائح الذكاء الاصطناعي',
  quotaSmartTasks: 'المهام الذكية',
  quotaUpgrade: 'ترقية',
  quotaLimitReached: 'تم الوصول للحد اليومي',
  quotaTodayFree: 'استخدامات مجانية اليوم',

  // Calendar Export (Arabic)
  calendarExport: 'تصدير',
  calendarExportTitle: 'تصدير المهام',
  calendarExportTasksCount: 'مهام نشطة',
  calendarDownloadICS: 'تحميل ملف .ics',
  calendarICSHint: 'يعمل مع أي تطبيق تقويم',
  calendarAddGoogle: 'إضافة إلى تقويم Google',
  calendarAddOutlook: 'إضافة إلى Outlook',
  calendarOpenNew: 'يفتح في نافذة جديدة',
  calendarExportAll: 'تصدير الكل',
  calendarExportDownloaded: 'تم التصدير!',
  calendarExporting: 'جاري الفتح',
  calendarPopupNote: 'اسمح بالنوافذ المنبثقة لهذا الموقع. كل مهمة تفتح معبأة مسبقاً — فقط انقر حفظ.',
  calendarExportAllHint: 'إضافة جميع المهام مباشرة',

  // Project Teams Page (Arabic)
  projectTeamsLabel: 'فرق المشاريع',
  projectTeamsTitle: 'مشاريعك',
  projectTeamsSubtitle: 'تعاون مع فريقك على المهام والأهداف المشتركة.',
  projectTeamsNewProject: 'مشروع جديد',
  projectTeamsJoin: 'انضمام',
  projectTeamsMyProjects: 'مشاريعي',
  projectTeamsNoProjects: 'لا توجد مشاريع بعد.',
  projectTeamsSelectProject: 'اختر مشروعاً',
  projectTeamsSelectProjectHint: 'اختر مشروعاً من القائمة أو أنشئ مشروعاً جديداً.',
  projectTeamsCreateTitle: 'إنشاء مشروع جديد',
  projectTeamsProjectName: 'اسم المشروع',
  projectTeamsProjectNamePlaceholder: 'مثال: مشروع هندسة البرمجيات',
  projectTeamsDescriptionOptional: 'الوصف (اختياري)',
  projectTeamsDescriptionPlaceholder: 'ما هو هذا المشروع؟',
  projectTeamsCancel: 'إلغاء',
  projectTeamsCreateButton: 'إنشاء المشروع',
  projectTeamsJoinTitle: 'الانضمام إلى مشروع',
  projectTeamsInviteCodeLabel: 'رمز الدعوة',
  projectTeamsEnterCode: 'أدخل الرمز',
  projectTeamsJoinButton: 'انضمام للمشروع',
  projectTeamsInviteMember: 'دعوة عضو',
  projectTeamsLeaveProject: 'مغادرة المشروع',
  projectTeamsNoDescription: 'لا يوجد وصف',
  projectTeamsInviteTitle: 'دعوة أعضاء الفريق',
  projectTeamsInviteSubtitle: 'شارك هذا الرمز أو الرابط لدعوة الآخرين',
  projectTeamsInviteCode: 'رمز الدعوة',
  projectTeamsShareableLink: 'رابط المشاركة',
  projectTeamsCopyLink: 'نسخ الرابط',
  projectTeamsNoInviteCode: 'لا يوجد رمز دعوة لهذا المشروع.',
  projectTeamsInvitesDisabled: 'قد تكون الدعوات معطلة لهذا المشروع.',
  projectTeamsClose: 'إغلاق',
  projectTeamsProjectBoard: 'لوحة المشروع',
  projectTeamsAddTask: 'إضافة مهمة',
  projectTeamsToDo: 'للتنفيذ',
  projectTeamsInProgress: 'قيد التنفيذ',
  projectTeamsDone: 'مكتمل',
  projectTeamsNoTasks: 'لا توجد مهام',
  projectTeamsTeamMembers: 'أعضاء الفريق',
  projectTeamsNoMembers: 'لا يوجد أعضاء بعد',
  projectTeamsTasksDone: 'المهام المكتملة',
  projectTeamsAssignTo: 'تعيين إلى',
  projectTeamsNoTeamMembers: 'لا يوجد أعضاء في الفريق',
  projectTeamsAnyone: 'أي شخص لديه هذا الرمز يمكنه الانضمام',
  projectTeamsOwner: 'مالك',
  projectTeamsMember: 'عضو',

  // AI Task Prompt
  aiPromptPlaceholder: 'ماذا تحتاج أن تدرس؟ مثال: "امتحان رياضيات الخميس، مشروع حاسب الأسبوع القادم"',
  aiNoTasksFound: 'لم أتمكن من إيجاد مهام في رسالتك. حاول شيء مثل "امتحان رياضيات يوم الخميس"',
  aiParseError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  aiTasksAdded: 'تمت إضافة المهام إلى لوحتك!',
  aiFoundTask: 'تم إيجاد مهمة واحدة',
  aiFoundTasks: 'تم إيجاد {count} مهام',
  aiAddAll: 'إضافة الكل',
  tryAgain: 'حاول مرة أخرى',
};


export const translations: Record<Language, Translations> = {
  en: englishTranslations,
  ar: arabicTranslations,
};
